// Global Automotive Catalog MMYTE — Parts4Drive Marketplace
// Provides unified vehicle taxonomy, part categories, subcategories, and fitment matching

export { automotiveSlugify, unslugifyAutomotive } from './seo';

export interface VehicleMake {
  id: string
  name: string
  models: string[]
}

export const GLOBAL_MAKES: VehicleMake[] = [
  // ===== JAPANESE =====
  { id: 'toyota', name: 'Toyota', models: [
    'Corolla', 'Camry', 'Hilux', 'Land Cruiser', 'Prado', 'Yaris', 'Avensis', 'Rav4',
    'Highlander', 'Sienna', 'Matrix', 'Tacoma', 'Tundra', '4Runner', 'Fortuner',
    'Prius', 'Avalon', 'Sequoia', 'Venza', 'C-HR', 'Supra', 'Celica', 'MR2',
    'FJ Cruiser', 'Alphard', 'Vellfire', 'Harrier', 'Kluger', 'Wish', 'Innova',
    'Hiace', 'Rush', 'Etios', 'Corona', 'Tercel', 'Echo', 'Solara', 'Crown'
  ]},
  { id: 'honda', name: 'Honda', models: [
    'Civic', 'Accord', 'CR-V', 'Pilot', 'Fit', 'City', 'HR-V', 'Odyssey', 'Insight',
    'Ridgeline', 'Passport', 'Element', 'Prelude', 'S2000', 'Stream', 'Jazz',
    'BR-V', 'WR-V', 'Amaze', 'Mobilio', 'Airwave', 'Del Sol', 'Beat', 'Vezel', 'Stepwgn', 'CR-Z'
  ]},
  { id: 'nissan', name: 'Nissan', models: [
    'Altima', 'Sentra', 'Maxima', 'Rogue', 'Murano', 'Pathfinder', 'Xterra',
    'Frontier', 'Titan', 'Armada', 'Juke', 'Kicks', 'Versa', 'Patrol', 'Sunny',
    'X-Trail', 'Navara', 'Micra', 'Qashqai', 'Leaf', '370Z', '350Z', 'GT-R',
    'Skyline', 'Silvia', 'Almera', 'Terrano', 'Note', 'Pulsar', 'Teana', 'Urvan', 'NV200', 'NV350'
  ]},
  { id: 'hyundai', name: 'Hyundai', models: [
    'Elantra', 'Sonata', 'Accent', 'Tucson', 'Santa Fe', 'Palisade', 'Kona',
    'Venue', 'Ioniq', 'Ioniq 5', 'Ioniq 6', 'Veloster', 'Azera', 'Creta',
    'Alcazar', 'Staria', 'Starex', 'Getz', 'i10', 'i20', 'i30', 'i40',
    'ix20', 'ix35', 'Bayon', 'H-1', 'Veracruz', 'Equus', 'Entourage', 'Terracan', 'Matrix'
  ]},
  { id: 'kia', name: 'Kia', models: [
    'Rio', 'Forte', 'Optima', 'Sportage', 'Sorento', 'Telluride', 'Soul',
    'Seltos', 'Carnival', 'Stinger', 'Cadenza', 'K5', 'K7', 'K900', 'Niro',
    'EV6', 'EV9', 'Stonic', 'Cerato', 'Ceed', 'Picanto', 'Carens', 'Borrego',
    'Rondo', 'Spectra', 'Amanti', 'Sedona', 'Mohave'
  ]},
  { id: 'mitsubishi', name: 'Mitsubishi', models: [
    'Lancer', 'Outlander', 'Pajero', 'Pajero Sport', 'ASX', 'Eclipse Cross', 'Mirage', 'Galant',
    'Montero', 'Montero Sport', 'Triton', 'L200', 'Space Star', 'RVR',
    'Challenger', 'Delica', 'Colt', 'Evolution', 'Starion', '3000GT', 'Endeavor', 'Canter'
  ]},
  { id: 'suzuki', name: 'Suzuki', models: [
    'Swift', 'Baleno', 'Vitara', 'Jimny', 'S-Cross', 'Ciaz', 'Ertiga', 'Ignis',
    'Alto', 'Wagon R', 'Celerio', 'Dzire', 'XL7', 'Grand Vitara', 'Kizashi',
    'Samurai', 'Sidekick', 'SX4', 'S-Presso', 'Carry'
  ]},
  { id: 'mazda', name: 'Mazda', models: [
    'Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-5', 'CX-7', 'CX-9', 'CX-30', 'CX-50',
    'CX-60', 'CX-90', 'MX-5', 'MX-3', 'MX-6', 'BT-50', 'RX-7', 'RX-8',
    'Tribute', 'Protege', 'MPV', 'Miata'
  ]},
  { id: 'subaru', name: 'Subaru', models: [
    'Impreza', 'Legacy', 'Outback', 'Forester', 'Crosstrek', 'XV', 'WRX', 'STI',
    'BRZ', 'Ascent', 'Tribeca', 'Baja', 'Levorg', 'Exiga', 'Justy', 'R1', 'Leone'
  ]},
  { id: 'lexus', name: 'Lexus', models: [
    'CT', 'ES', 'ES300', 'ES330', 'ES350', 'GS', 'GS300', 'GS350', 'GS430',
    'GX', 'GX460', 'GX470', 'GX550', 'HS', 'IS', 'IS250', 'IS350', 'LC', 'LM', 'LS',
    'LS400', 'LS430', 'LS460', 'LS500', 'LX', 'LX470', 'LX570', 'LX600', 'NX', 'RC', 'RX',
    'RX300', 'RX330', 'RX350', 'RX400h', 'RX450h', 'SC', 'SC300', 'SC400', 'SC430', 'UX', 'TX', 'RZ'
  ]},
  { id: 'infiniti', name: 'Infiniti', models: [
    'Q50', 'Q60', 'Q70', 'QX30', 'QX50', 'QX55', 'QX60', 'QX70', 'QX80',
    'G20', 'G35', 'G37', 'M35', 'M37', 'M45', 'EX35', 'FX35', 'FX45',
    'JX35', 'I30', 'I35', 'Q45', 'QX4', 'QX56'
  ]},
  { id: 'acura', name: 'Acura', models: [
    'TL', 'TLX', 'TSX', 'ILX', 'RLX', 'RDX', 'MDX', 'ZDX', 'NSX', 'Integra',
    'Legend', 'Vigor', 'CL', 'SLX', 'RSX', 'CSX', 'EL'
  ]},
  { id: 'isuzu', name: 'Isuzu', models: [
    'D-Max', 'MU-X', 'Trooper', 'Rodeo', 'Pickup', 'KB', 'Ascender', 'Hombre',
    'i-Series', 'Panther', 'Elf', 'Forward', 'F-Series', 'N-Series', 'Reach',
    'VehiCROSS', 'Amigo', 'Rodeo Sport'
  ]},
  { id: 'daihatsu', name: 'Daihatsu', models: [
    'Terios', 'Mira', 'Move', 'Sirion', 'Copen', 'Cuore', 'Charade', 'Feroza',
    'Rocky', 'Hijet', 'Gran Max', 'Luxio', 'Ayla', 'Xenia'
  ]},

  // ===== KOREAN =====
  { id: 'genesis', name: 'Genesis', models: ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80', 'Coupe'] },
  { id: 'ssangyong', name: 'SsangYong', models: ['Rexton', 'Korando', 'Tivoli', 'Musso', 'Actyon', 'Kyron', 'Rodius', 'Stavic', 'Chairman'] },
  { id: 'daewoo', name: 'Daewoo', models: ['Lanos', 'Nubira', 'Leganza', 'Matiz', 'Kalos', 'Lacetti', 'Evanda', 'Tacuma', 'Captiva'] },

  // ===== GERMAN =====
  { id: 'mercedes-benz', name: 'Mercedes-Benz', models: [
    'A-Class', 'B-Class', 'C-Class', 'C180', 'C200', 'C230', 'C250', 'C280',
    'C300', 'C320', 'C350', 'C400', 'C43', 'C63', 'E-Class', 'E200', 'E230',
    'E250', 'E300', 'E320', 'E350', 'E400', 'E500', 'E550', 'E63', 'S-Class',
    'S400', 'S430', 'S500', 'S550', 'S600', 'S63', 'S65', 'GLA', 'GLB',
    'GLC', 'GLE', 'GLK', 'GLK350', 'GLS', 'G-Class', 'CLA', 'CLK', 'CLS',
    'ML', 'ML320', 'ML350', 'ML500', 'GL', 'GL450', 'GL550', 'SL', 'SLC',
    'SLK', 'Sprinter', 'Vito', 'V-Class', 'Metris', 'AMG GT', 'Maybach'
  ]},
  { id: 'bmw', name: 'BMW', models: [
    '1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series',
    '7 Series', '8 Series', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7',
    'Z3', 'Z4', 'Z8', 'i3', 'i4', 'i8', 'iX', 'M2', 'M3', 'M4', 'M5',
    'M6', 'M8', 'X3 M', 'X4 M', 'X5 M', 'X6 M'
  ]},
  { id: 'audi', name: 'Audi', models: [
    'A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8',
    'TT', 'R8', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'RS3', 'RS4', 'RS5',
    'RS6', 'RS7', 'SQ5', 'SQ7', 'e-tron', 'Q4 e-tron', 'Q8 e-tron'
  ]},
  { id: 'volkswagen', name: 'Volkswagen', models: [
    'Golf', 'Polo', 'Passat', 'Jetta', 'Tiguan', 'Touareg', 'Arteon', 'T-Roc',
    'T-Cross', 'Taos', 'Vento', 'Beetle', 'Caddy', 'Transporter', 'Amarok',
    'Touran', 'Sharan', 'Phaeton', 'Bora', 'Scirocco', 'CC', 'Eos', 'GTI',
    'GLI', 'ID.4', 'ID.5', 'up!', 'Virtus', 'Crafter'
  ]},
  { id: 'porsche', name: 'Porsche', models: [
    '911', '718', 'Boxster', 'Cayman', 'Cayenne', 'Macan', 'Panamera',
    'Taycan', 'Carrera', 'GT3', 'GT2', 'GT4', '944', '928', '968'
  ]},
  { id: 'opel', name: 'Opel', models: ['Astra', 'Corsa', 'Insignia', 'Mokka', 'Zafira', 'Vectra', 'Meriva', 'Antara', 'Combo', 'Adam', 'Crossland', 'Grandland'] },

  // ===== AMERICAN =====
  { id: 'ford', name: 'Ford', models: [
    'Focus', 'Fiesta', 'Fusion', 'Edge', 'Escape', 'Explorer', 'Ranger',
    'F-150', 'F-250', 'F-350', 'Mustang', 'EcoSport', 'Kuga', 'Mondeo',
    'Transit', 'Bronco', 'Everest', 'Expedition', 'Maverick', 'Taurus',
    'Thunderbird', 'Falcon', 'Cortina', 'Escort', 'Capri', 'Sierra', 'Granada',
    'Windstar', 'Aerostar', 'Excursion', 'Territory', 'Crown Victoria'
  ]},
  { id: 'chevrolet', name: 'Chevrolet', models: [
    'Cruze', 'Malibu', 'Spark', 'Trax', 'Equinox', 'Traverse', 'Colorado',
    'Silverado', 'Camaro', 'Corvette', 'Aveo', 'Captiva', 'Orlando', 'Sail',
    'Suburban', 'Tahoe', 'Blazer', 'Trailblazer', 'Impala', 'Sonic', 'Volt',
    'Bolt', 'Avalanche', 'S-10', 'Express', 'Astro', 'Lumina', 'Monte Carlo',
    'Cavalier', 'Cobalt', 'HHR', 'Spin', 'Onix', 'Tracker'
  ]},
  { id: 'gmc', name: 'GMC', models: [
    'Sierra', 'Yukon', 'Terrain', 'Acadia', 'Canyon', 'Envoy', 'Jimmy',
    'Typhoon', 'Cyclone', 'Savana', 'Sonoma', 'C/K'
  ]},
  { id: 'cadillac', name: 'Cadillac', models: [
    'Escalade', 'CTS', 'ATS', 'XTS', 'STS', 'DTS', 'SRX', 'XT4', 'XT5',
    'XT6', 'CT4', 'CT5', 'CT6', 'Lyriq', 'Eldorado', 'Seville', 'DeVille',
    'Fleetwood', 'Brougham'
  ]},
  { id: 'buick', name: 'Buick', models: [
    'Enclave', 'Encore', 'Envision', 'LaCrosse', 'Regal', 'Verano', 'Century',
    'LeSabre', 'Park Avenue', 'Riviera', 'Roadmaster', 'Skylark'
  ]},
  { id: 'lincoln', name: 'Lincoln', models: [
    'Navigator', 'Continental', 'Town Car', 'MKZ', 'MKC', 'MKT', 'MKX',
    'Nautilus', 'Aviator', 'Corsair'
  ]},
  { id: 'chrysler', name: 'Chrysler', models: ['300', '200', 'Town & Country', 'Pacifica', 'Voyager', 'Sebring', 'Concorde', 'LHS', 'PT Cruiser', 'Crossfire'] },
  { id: 'dodge', name: 'Dodge', models: [
    'Charger', 'Challenger', 'Durango', 'Journey', 'Caravan', 'Grand Caravan',
    'Avenger', 'Caliber', 'Dart', 'Neon', 'Viper', 'Magnum', 'Nitro',
    'Intrepid', 'Stratus', 'Dakota', '1500', '2500', '3500', '4500', '5500'
  ]},
  { id: 'ram', name: 'RAM', models: ['1500', '2500', '3500', '4500', '5500', 'ProMaster', 'ProMaster City', 'Dakota'] },
  { id: 'jeep', name: 'Jeep', models: [
    'Wrangler', 'Grand Cherokee', 'Cherokee', 'Compass', 'Renegade',
    'Gladiator', 'Liberty', 'Patriot', 'Commander', 'Comanche', 'Wagoneer',
    'Grand Wagoneer'
  ]},
  { id: 'tesla', name: 'Tesla', models: ['Model S', 'Model 3', 'Model X', 'Model Y', 'Roadster', 'Cybertruck', 'Semi'] },
  { id: 'hummer', name: 'Hummer', models: ['H1', 'H2', 'H3', 'EV'] },

  // ===== BRITISH =====
  { id: 'land-rover', name: 'Land Rover', models: [
    'Defender', 'Discovery', 'Discovery Sport', 'Range Rover',
    'Range Rover Sport', 'Range Rover Velar', 'Range Rover Evoque',
    'Freelander', 'LR2', 'LR3', 'LR4', 'Series I', 'Series II', 'Series III'
  ]},
  { id: 'jaguar', name: 'Jaguar', models: ['XE', 'XF', 'XJ', 'XK', 'F-Type', 'F-Pace', 'E-Pace', 'I-Pace', 'S-Type', 'X-Type', 'XJS'] },
  { id: 'bentley', name: 'Bentley', models: ['Continental', 'Flying Spur', 'Bentayga', 'Mulsanne', 'Arnage', 'Azure', 'Brooklands'] },
  { id: 'rolls-royce', name: 'Rolls-Royce', models: ['Phantom', 'Ghost', 'Wraith', 'Dawn', 'Cullinan', 'Spectre', 'Silver Shadow', 'Silver Spirit'] },
  { id: 'mini', name: 'Mini', models: ['Cooper', 'Countryman', 'Clubman', 'Convertible', 'Paceman', 'Coupe', 'Roadster'] },

  // ===== ITALIAN =====
  { id: 'fiat', name: 'Fiat', models: ['500', '500L', '500X', 'Panda', 'Punto', 'Bravo', 'Tipo', 'Doblo', 'Ducato', 'Uno', 'Palio', 'Linea', 'Stilo', 'Idea', 'Punto Evo'] },
  { id: 'alfa-romeo', name: 'Alfa Romeo', models: ['Giulia', 'Giulietta', 'Stelvio', 'Tonale', 'MiTo', '159', '147', '156', 'Brera', 'Spider', '4C', '8C'] },
  { id: 'maserati', name: 'Maserati', models: ['Ghibli', 'Quattroporte', 'GranTurismo', 'GranCabrio', 'Levante', 'Grecale', 'MC20', '3200 GT', 'Coupe', 'Spyder'] },

  // ===== FRENCH =====
  { id: 'peugeot', name: 'Peugeot', models: [
    '108', '208', '308', '408', '508', '2008', '3008', '5008', 'Partner',
    'Expert', 'Boxer', '206', '207', '301', '307', '406', '407', '504', '505',
    '607', '107', '1007', '4007', '4008', 'RCZ', 'Bipper', 'Rifter', 'Traveller'
  ]},
  { id: 'renault', name: 'Renault', models: [
    'Clio', 'Megane', 'Kadjar', 'Captur', 'Koleos', 'Talisman', 'Scenic',
    'Laguna', 'Twingo', 'Symbol', 'Logan', 'Duster', 'Sandero', 'Dokker',
    'Zoe', 'Kangoo', 'Trafic', 'Master', 'Espace', 'Fluence', 'Latitude',
    'Modus', 'Vel Satis', 'Avantime', 'Kwid'
  ]},

  // ===== SWEDISH =====
  { id: 'volvo', name: 'Volvo', models: [
    'S40', 'S60', 'S70', 'S80', 'S90', 'V40', 'V50', 'V60', 'V70', 'V90',
    'XC40', 'XC60', 'XC70', 'XC90', 'C30', 'C70', '240', '740', '850', '940', '960'
  ]},

  // ===== ASIAN & CHINESE EMERGING FLEETS =====
  { id: 'chery', name: 'Chery', models: ['Tiggo 2', 'Tiggo 4 Pro', 'Tiggo 7 Pro', 'Tiggo 8 Pro', 'Arrizo 5', 'Arrizo 6'] },
  { id: 'geely', name: 'Geely', models: ['Emgrand', 'Coolray', 'Azkarra', 'Tugella', 'Monjaro', 'Okavango', 'GX3 Pro'] },
  { id: 'changan', name: 'Changan', models: ['CS35 Plus', 'CS55 Plus', 'CS75 Plus', 'CS85', 'CS95', 'Alsvin', 'Eado', 'Hunter'] },
  { id: 'gwm-haval', name: 'Haval / GWM', models: ['Haval H6', 'Haval Jolion', 'Haval H9', 'GWM P-Series', 'GWM Steed', 'Tank 300', 'Tank 500'] },
  { id: 'byd', name: 'BYD', models: ['Atto 3', 'Dolphin', 'Seal', 'Han', 'Tang', 'Song', 'Qin', 'Yuan', 'e6', 'F3'] },
  { id: 'mahindra', name: 'Mahindra', models: ['Scorpio', 'XUV500', 'XUV700', 'Thar', 'Bolero', 'Xylo', 'KUV100', 'Marazzo', 'Alturas'] },
  { id: 'tata', name: 'Tata', models: ['Nexon', 'Harrier', 'Safari', 'Altroz', 'Tiago', 'Tigor', 'Hexa', 'Sumo', 'Indica', 'Indigo'] }
]

export const MAKES = GLOBAL_MAKES

export const YEARS = Array.from({ length: 47 }, (_, i) => 2026 - i)

// 44 Standard Powertrains & Configurations
export const ENGINE_CONFIGURATIONS = [
  '1.0L 3-Cylinder', '1.2L 3-Cylinder', '1.2L 4-Cylinder', '1.3L 4-Cylinder', '1.4L 4-Cylinder',
  '1.5L 4-Cylinder', '1.6L 4-Cylinder', '1.8L 4-Cylinder', '2.0L 4-Cylinder', '2.0L 4-Cylinder Turbo',
  '2.2L 4-Cylinder', '2.4L 4-Cylinder', '2.5L 4-Cylinder', '2.7L V6', '2.8L Diesel Turbo',
  '3.0L V6', '3.0L V6 Twin-Turbo', '3.2L V6', '3.3L V6', '3.5L V6', '3.6L V6', '3.7L V6', '3.8L V6',
  '4.0L V6', '4.2L V8', '4.4L V8 Twin-Turbo', '4.6L V8', '4.7L V8', '5.0L V8', '5.3L V8', '5.7L V8',
  '6.0L V8', '6.2L V8', '6.4L V8', '6.6L V8 (Diesel)', '6.7L I6 (Diesel)',
  'Hybrid 1.5L', 'Hybrid 1.8L', 'Hybrid 2.0L', 'Hybrid 2.5L', 'Hybrid 3.5L V6',
  'Plug-in Hybrid 2.0L', 'Plug-in Hybrid 3.0L', 'Electric (BEV)', 'Electric (PHEV)',
  '1.5L Diesel', '1.6L Turbo Diesel', '2.0L Turbo Diesel', '2.2L Turbo Diesel', '2.8L Turbo Diesel',
  '3.0L Turbo Diesel', '3.5L Turbo Diesel', 'Rotary'
]

export const DEFAULT_ENGINES = ENGINE_CONFIGURATIONS

// Comprehensive Global Car Trims
export const CAR_TRIMS = [
  'Base / Standard', 'LE', 'SE', 'XLE', 'XSE', 'Sport', 'SR', 'SR5', 'Limited', 'Platinum',
  'TRD', 'TRD Off-Road', 'TRD Pro', 'Nightshade', 'Trail',
  'LX', 'EX', 'EX-L', 'EX-L Navi', 'Touring', 'Type R', 'Type S', 'A-Spec',
  'S', 'SV', 'SL', 'Midnight Edition', 'PRO-4X', 'Nismo',
  'GLS', 'SEL', 'Calligraphy', 'Ultimate', 'N Line', 'N',
  'GT-Line', 'SX', 'EX Premium', 'GT', 'X-Line', 'X-Pro',
  'XL', 'XLT', 'Lariat', 'King Ranch', 'Raptor', 'ST', 'RS', 'Titanium', 'Tremor', 'Wildtrak',
  'LS', 'LT', 'LTZ', 'Premier', 'High Country', 'Z71', 'ZR2', 'RST', 'Custom', 'Trail Boss',
  'SLE', 'SLT', 'AT4', 'AT4X', 'Denali', 'Denali Ultimate', 'Elevation',
  'Tradesman', 'Big Horn', 'Lone Star', 'Laramie', 'Longhorn', 'Rebel', 'TRX',
  'SXT', 'R/T', 'SRT', 'SRT Hellcat', 'Scat Pack', 'Daytona',
  'Sport Line', 'Luxury Line', 'M Sport', 'M Sport Package', 'xLine', 'Competition', 'M',
  'AMG Line', 'Avantgarde', 'Elegance', 'Exclusive', 'AMG', 'Designo', 'Night Package', 'Maybach',
  'Komfort', 'Progressiv', 'Technik', 'Premium', 'Premium Plus', 'Prestige', 'S Line', 'Black Edition',
  'Trendline', 'Comfortline', 'Highline', 'R-Line', 'GTI', 'GLI', 'R',
  'Momentum', 'Inscription', 'R-Design', 'Polestar', 'Cross Country', 'Core', 'Plus',
  'HSE', 'HSE Luxury', 'R-Dynamic', 'First Edition', 'Autobiography', 'SVAutobiography', 'Dynamic SE', 'Dynamic HSE',
  'Altitude', 'Overland', 'Summit', 'Trailhawk', 'Sahara', 'Rubicon', 'Willys', 'Latitude', 'Sport S',
  'Comfort', 'Executive', 'Signature', 'Elite', 'Luxury', 'Ultra Luxury', 'F Sport',
  'Pure', 'Luxe', 'Essential', 'Sensory', 'Autograph', 'Red Sport'
]

export const DEFAULT_TRIMS = CAR_TRIMS

// Make-Specific Trim Dictionary
export const MAKE_TRIMS: Record<string, string[]> = {
  Toyota: ['Base / Standard', 'LE', 'SE', 'XLE', 'XSE', 'SR', 'SR5', 'Limited', 'Platinum', 'TRD', 'TRD Off-Road', 'TRD Pro', 'Nightshade', 'Trail', 'Sport'],
  Honda: ['Base / Standard', 'LX', 'EX', 'EX-L', 'EX-L Navi', 'Touring', 'Sport', 'Type R', 'Type S', 'Elite', 'Special Edition'],
  Nissan: ['Base / Standard', 'S', 'SV', 'SL', 'SR', 'Platinum', 'PRO-4X', 'Midnight Edition', 'Nismo'],
  Hyundai: ['Base / Standard', 'SE', 'SEL', 'Limited', 'Calligraphy', 'N Line', 'N', 'Ultimate', 'GLS'],
  Kia: ['Base / Standard', 'LX', 'S', 'EX', 'SX', 'SX Prestige', 'GT-Line', 'GT', 'X-Line', 'X-Pro'],
  Ford: ['Base / Standard', 'XL', 'XLT', 'Lariat', 'King Ranch', 'Platinum', 'Limited', 'Titanium', 'ST', 'RS', 'Raptor', 'Tremor', 'Wildtrak'],
  Chevrolet: ['Base / Standard', 'LS', 'LT', 'LTZ', 'Premier', 'High Country', 'Z71', 'ZR2', 'RST', 'Custom', 'Trail Boss'],
  GMC: ['Base / Standard', 'SLE', 'SLT', 'AT4', 'AT4X', 'Denali', 'Denali Ultimate', 'Elevation'],
  BMW: ['Base / Standard', 'Advantage', 'Sport Line', 'Luxury Line', 'M Sport', 'xLine', 'Competition', 'CS', 'M'],
  'Mercedes-Benz': ['Base / Standard', 'AMG Line', 'Avantgarde', 'Elegance', 'Exclusive', 'AMG', 'Designo', 'Night Package', 'Maybach'],
  Audi: ['Base / Standard', 'Komfort', 'Progressiv', 'Technik', 'Premium', 'Premium Plus', 'Prestige', 'S Line', 'Black Edition'],
  Volkswagen: ['Base / Standard', 'Trendline', 'Comfortline', 'Highline', 'R-Line', 'GTI', 'GLI', 'R', 'SEL', 'SE'],
  Lexus: ['Base / Standard', 'Premium', 'Luxury', 'Ultra Luxury', 'F Sport', 'Executive', 'Sport Design'],
  Jeep: ['Base / Standard', 'Sport', 'Sport S', 'Latitude', 'Altitude', 'Sahara', 'Rubicon', 'Overland', 'Summit', 'Trailhawk', 'Willys'],
  Dodge: ['Base / Standard', 'SXT', 'GT', 'R/T', 'Scat Pack', 'SRT', 'SRT Hellcat', 'Daytona'],
  Ram: ['Base / Standard', 'Tradesman', 'Big Horn', 'Lone Star', 'Laramie', 'Rebel', 'Longhorn', 'Limited', 'TRX'],
  RAM: ['Base / Standard', 'Tradesman', 'Big Horn', 'Lone Star', 'Laramie', 'Rebel', 'Longhorn', 'Limited', 'TRX'],
  Mazda: ['Base / Standard', 'Sport', 'Touring', 'Grand Touring', 'Signature', 'Carbon Edition', 'Select', 'Preferred', 'Premium'],
  Subaru: ['Base / Standard', 'Premium', 'Sport', 'Limited', 'Touring', 'Wilderness', 'Onyx Edition', 'WRX', 'STI'],
  'Land Rover': ['Base / Standard', 'S', 'SE', 'HSE', 'HSE Luxury', 'R-Dynamic', 'First Edition', 'Autobiography', 'SVAutobiography', 'Dynamic SE', 'Dynamic HSE'],
  Mitsubishi: ['Base / Standard', 'ES', 'LE', 'SE', 'SEL', 'GT', 'Ralliart', 'Black Edition'],
  Peugeot: ['Base / Standard', 'Active', 'Allure', 'GT Line', 'GT'],
  Renault: ['Base / Standard', 'Life', 'Zen', 'Intens', 'RS Line', 'GT Line']
}

// 20 Canonical Categories
export const CANONICAL_CATEGORIES = [
  'BRAKING', 'FILTRATION', 'IGNITION', 'SUSPENSION', 'STEERING',
  'ENGINE', 'ELECTRICAL', 'LIGHTING', 'COOLING', 'HVAC',
  'TRANSMISSION', 'BODY', 'EXHAUST', 'FUEL SYSTEM', 'INTERIOR',
  'WHEELS', 'HARDWARE', 'EV', 'ADAS', 'GENERAL'
]

// Automotive Part Brands (OEM & Tier-1 Aftermarket)
export const PART_BRANDS = [
  'Toyota Genuine',
  'Honda Genuine',
  'Nissan Genuine',
  'Hyundai / Kia Mobis',
  'Mercedes-Benz Genuine',
  'BMW Genuine',
  'Volkswagen / Audi Genuine',
  'Ford Motorcraft',
  'GM Genuine Parts / ACDelco',
  'Mopar Genuine',
  'Mitsubishi Genuine',
  'Subaru Genuine',
  'Mazda Genuine',
  'Land Rover Genuine',
  'Genuine OEM (Original Equipment)',
  'Bosch',
  'Denso',
  'NGK / NTK',
  'Brembo',
  'Akebono',
  'TRW',
  'ATE',
  'Textar',
  'Ferodo',
  'Wagner',
  'KYB (Kayaba)',
  'Monroe',
  'Bilstein',
  'Sachs',
  'Lemförder',
  'MOOG',
  'Febi Bilstein',
  'Meyle',
  'SKF',
  'Timken',
  'FAG / INA (Schaeffler)',
  'Koyo',
  'NSK',
  'NTN',
  '555 (Sankei)',
  'CTR',
  'GMB',
  'Gates',
  'Dayco',
  'Contitech (Continental)',
  'Bando',
  'Mitsuboshi',
  'Valeo',
  'Nissens',
  'Behr (Mahle)',
  'Sanden',
  'Mann-Filter',
  'Mahle / Knecht',
  'Wix Filters',
  'Fram',
  'K&N Engineering',
  'Donaldson',
  'Baldwin',
  'Hengst',
  'Delphi Technologies',
  'Hitachi Astemo',
  'Hella',
  'Philips Automotive',
  'Osram',
  'Standard Motor Products (SMP)',
  'Dorman Products',
  'Aisin',
  'ZF Transmissions',
  'Luk (Schaeffler)',
  'Exedy',
  'BorgWarner',
  'Garrett Motion',
  'Elring',
  'Victor Reinz',
  'Fel-Pro',
  'Certified Tier-1 Aftermarket',
  'Tokunbo / Tested OEM Salvage',
  'CATL',
  'BYD FinDreams',
  'Fuyao Glass',
  'HASCO (Huayu Automotive)',
  'CITIC Dicastal',
  'Weichai Power',
  'Minth Group',
  'Ningbo Joyson Electronics',
  'Wanxiang Group',
  'GSP Automotive Group',
  'Bethel Automotive Safety Systems',
  'Zhejiang Yueling',
  'Desay SV',
  'Huizhou Sanhua',
  'Fastwin Auto Parts',
  'Hebei Xiangdie',
  'Zhejiang Asia-Pacific',
  'Autorova Auto Parts',
  'Ketai Industries',
  'GDST Auto Parts',
  'Motortec',
  'Kuante Auto Parts',
  'Tong Yang Group',
  'Gordon Auto Body Parts',
  'Taiwan Kai Yih (TKY)',
  'Depo Auto Parts',
  'TYC Brother Industrial',
  'AnzoUSA / Eagle Eyes',
  'Maxxis (Cheng Shin)',
  'Federal Tires',
  'SuperAlloy Industrial (SAI)',
  '555 / San Fu',
  'Tung Thih Electronic (TTE)',
  'Cub Elecparts',
  'Siruda (Micro-Tech)',
  'Cryomax Cooling System',
  'Hyundai Mobis',
  'HL Mando',
  'Hyundai Wia',
  'LG Energy Solution',
  'Samsung SDI',
  'SK On',
  'Hanon Systems',
  'Hankook Tire',
  'Kumho Tire',
  'Nexen Tire',
  'CTR (Central Corp)',
  'Sangsin Brake (Hi-Q / Hagen)',
  'SL Corporation',
  'LG Electronics VS',
  'Walker Exhaust',
  'Bendix Brakes',
  'Cardone Industries',
  'Dana / Spicer',
  'PartSouq Global',
  'Triple A Trading Dubai',
  'Star X Auto Trade',
  'AlZayan Auto Spare Parts',
  'Parts Gallary Dubai',
  'Motorline FZCO',
  'LUK International (Royal Super)',
  'Partfinder UAE'
]

export interface CategoryData {
  id: string
  name: string
  code: string
  icon: string
  subcategories: string[]
}

export const MMYTE_CATEGORIES: CategoryData[] = [
  {
    id: 'braking',
    name: 'Braking System',
    code: 'BRK',
    icon: 'Disc',
    subcategories: [
      'Brake Pads',
      'Brake Rotors & Discs',
      'Brake Calipers',
      'Master Cylinders',
      'Brake Boosters',
      'Brake Lines & Hoses',
      'ABS Wheel Speed Sensors',
      'Brake Drum Assemblies'
    ]
  },
  {
    id: 'engine',
    name: 'Engine Components',
    code: 'ENG',
    icon: 'Cpu',
    subcategories: [
      'Timing Belt & Chain Kits',
      'Engine Mounts',
      'Gaskets & Seals',
      'Cylinder Heads',
      'Pistons & Rings',
      'Valves & Camshafts',
      'Oil Pumps',
      'Turbos & Superchargers'
    ]
  },
  {
    id: 'suspension',
    name: 'Suspension System',
    code: 'SUS',
    icon: 'Move',
    subcategories: [
      'Shock Absorbers & Struts',
      'Lower & Upper Control Arms',
      'Ball Joints',
      'Sway Bar Links',
      'Coil Springs',
      'Suspension Bushings',
      'Strut Mounts'
    ]
  },
  {
    id: 'steering',
    name: 'Steering System',
    code: 'STR',
    icon: 'Compass',
    subcategories: [
      'Steering Racks & Pinions',
      'Power Steering Pumps',
      'Tie Rod Ends',
      'Steering Columns',
      'Steering Knuckles',
      'Power Steering Hoses'
    ]
  },
  {
    id: 'electrical',
    name: 'Electrical & Electronics',
    code: 'ELE',
    icon: 'Zap',
    subcategories: [
      'Alternators & Regulators',
      'Starter Motors',
      'Car Batteries',
      'Engine Control Units (ECU)',
      'Wiring Harnesses',
      'Relays & Fuses',
      'Horns & Clocksprings'
    ]
  },
  {
    id: 'lighting',
    name: 'Lighting & Visibility',
    code: 'LGT',
    icon: 'Sun',
    subcategories: [
      'Headlight Assemblies (LED/Xenon)',
      'Tail Light Assemblies',
      'Fog Light Lamps',
      'Indicators & Turn Signals',
      'Brake Lights',
      'Side Mirrors & Glass',
      'Wiper Blades & Motors'
    ]
  },
  {
    id: 'transmission',
    name: 'Transmission & Drivetrain',
    code: 'TRN',
    icon: 'Cog',
    subcategories: [
      'Clutch Plate Kits & Flywheels',
      'CV Axles & Drive Shafts',
      'Automatic Gearboxes',
      'Manual Transmissions',
      'Differentials & Bearings',
      'Transmission Mounts',
      'Torque Converters'
    ]
  },
  {
    id: 'cooling',
    name: 'Engine Cooling',
    code: 'CLG',
    icon: 'Fan',
    subcategories: [
      'Engine Radiators',
      'Water Pumps',
      'Engine Thermostats & Housings',
      'Radiator Cooling Fans',
      'Expansion Water Tanks',
      'Coolant Flanges & Hoses'
    ]
  },
  {
    id: 'hvac',
    name: 'Heating & AC (HVAC)',
    code: 'HVC',
    icon: 'ThermometerSnowflake',
    subcategories: [
      'AC Compressors & Clutches',
      'AC Condensers',
      'Evaporator Cores',
      'Blower Motors',
      'Heater Cores',
      'AC Expansion Valves',
      'Refrigerant Pressure Hoses'
    ]
  },
  {
    id: 'filtration',
    name: 'Filters & Service',
    code: 'FLT',
    icon: 'Filter',
    subcategories: [
      'Engine Oil Filters',
      'Air Intake Filters',
      'Cabin Air Pollen Filters',
      'Fuel Filters',
      'Transmission Filters',
      'Service Kits'
    ]
  },
  {
    id: 'ignition',
    name: 'Ignition System',
    code: 'IGN',
    icon: 'Flame',
    subcategories: [
      'Iridium Spark Plugs',
      'Ignition Coils & Packs',
      'Glow Plugs (Diesel)',
      'Distributors & Caps',
      'Spark Plug High Tension Wires'
    ]
  },
  {
    id: 'fuel',
    name: 'Fuel Supply & Injection',
    code: 'FUE',
    icon: 'Fuel',
    subcategories: [
      'Electric Fuel Pump Modules',
      'High-Pressure Fuel Injectors',
      'Fuel Tanks & Sending Units',
      'Fuel Pressure Regulators',
      'Throttle Bodies'
    ]
  },
  {
    id: 'exhaust',
    name: 'Exhaust & Emissions',
    code: 'EXH',
    icon: 'Wind',
    subcategories: [
      'Catalytic Converters',
      'Exhaust Mufflers & Silencers',
      'Exhaust Manifolds',
      'Oxygen O2 Sensors',
      'DPF Diesel Particulate Filters',
      'Exhaust Resonators & Clamps'
    ]
  },
  {
    id: 'body',
    name: 'Body, Trim & Panels',
    code: 'BDY',
    icon: 'Shield',
    subcategories: [
      'Front & Rear Bumpers',
      'Front Radiator Grilles',
      'Fenders & Quarter Panels',
      'Engine Bonnets & Hoods',
      'Vehicle Doors & Shells',
      'Door Handles & Window Regulators',
      'Trunk Lids & Tailgates'
    ]
  },
  {
    id: 'wheels',
    name: 'Wheels, Hubs & Bearings',
    code: 'WHL',
    icon: 'CircleDot',
    subcategories: [
      'Wheel Bearing Kits',
      'Wheel Hub Assemblies',
      'Alloy Rims & Steel Wheels',
      'Tires',
      'Lug Nuts, Bolts & Studs',
      'TPMS Tire Pressure Sensors'
    ]
  },
  {
    id: 'interior',
    name: 'Cabin & Interior',
    code: 'INT',
    icon: 'Armchair',
    subcategories: [
      'Seats & Headrests',
      'Dashboards & Binnacles',
      'Airbags & Steering Wheels',
      'Center Consoles',
      'Window Switch Clusters',
      'Seat Belt Assemblies'
    ]
  },
  {
    id: 'hardware',
    name: 'Hardware & Fasteners',
    code: 'HDW',
    icon: 'Wrench',
    subcategories: [
      'Automotive Bolts & Screws',
      'Nuts & Washers',
      'Body Retaining Clips',
      'Mounting Brackets',
      'Sealing Rubber Grommets'
    ]
  },
  {
    id: 'ev',
    name: 'EV & Hybrid Powertrain',
    code: 'EVP',
    icon: 'BatteryCharging',
    subcategories: [
      'High-Voltage Traction Batteries',
      'Electric Drive Motors',
      'Power Inverters & Converters',
      'On-Board Chargers',
      'High Voltage Cables & Ports',
      'Battery Management System (BMS)'
    ]
  },
  {
    id: 'adas',
    name: 'ADAS, Sensors & Vision',
    code: 'ADS',
    icon: 'Eye',
    subcategories: [
      'Windshield ADAS Cameras',
      'Forward Radar Sensors',
      'Ultrasonic Parking Sensors',
      'Blind Spot Warning Radars',
      'LiDAR Modules',
      'Surround View Cameras'
    ]
  },
  {
    id: 'general',
    name: 'Fluids & Maintenance',
    code: 'FLU',
    icon: 'Droplets',
    subcategories: [
      'Synthetic Motor Oils',
      'DOT 4 & DOT 5.1 Brake Fluids',
      'Automatic & Manual Transmission Fluids',
      'Coolant & Antifreeze',
      'Power Steering Fluids',
      'Brake Cleaners & Degreasers'
    ]
  }
]

// Natural language keywords mapping
export const MMYTE_KEYWORDS = [
  { term: 'brake pad', category: 'braking', subcategory: 'Brake Pads' },
  { term: 'rotor', category: 'braking', subcategory: 'Brake Rotors & Discs' },
  { term: 'disc', category: 'braking', subcategory: 'Brake Rotors & Discs' },
  { term: 'caliper', category: 'braking', subcategory: 'Brake Calipers' },
  { term: 'shock', category: 'suspension', subcategory: 'Shock Absorbers & Struts' },
  { term: 'absorber', category: 'suspension', subcategory: 'Shock Absorbers & Struts' },
  { term: 'control arm', category: 'suspension', subcategory: 'Lower & Upper Control Arms' },
  { term: 'bush', category: 'suspension', subcategory: 'Lower & Upper Control Arms' },
  { term: 'tie rod', category: 'suspension', subcategory: 'Tie Rod Ends' },
  { term: 'link', category: 'suspension', subcategory: 'Stabilizer Sway Bar Links' },
  { term: 'rack', category: 'suspension', subcategory: 'Steering Racks & Pumps' },
  { term: 'oil filter', category: 'filtration', subcategory: 'Engine Oil Filters' },
  { term: 'air filter', category: 'filtration', subcategory: 'Air Intake Filters' },
  { term: 'spark plug', category: 'ignition', subcategory: 'Iridium Spark Plugs' },
  { term: 'coil', category: 'ignition', subcategory: 'Ignition Coils & Packs' },
  { term: 'alternator', category: 'ignition', subcategory: 'Alternators & Regulators' },
  { term: 'starter', category: 'ignition', subcategory: 'Starter Motors' },
  { term: 'radiator', category: 'cooling', subcategory: 'Engine Radiators' },
  { term: 'fan', category: 'cooling', subcategory: 'Radiator Cooling Fans' },
  { term: 'clutch', category: 'transmission', subcategory: 'Clutch Plate Kits & Flywheels' },
  { term: 'axle', category: 'transmission', subcategory: 'CV Axle Drive Shafts' },
  { term: 'headlight', category: 'lighting', subcategory: 'Headlight Assemblies (LED/Xenon)' },
  { term: 'bumper', category: 'body', subcategory: 'Front & Rear Bumpers' }
]

// Fitment compatibility checker and vehicle-to-product matching engine
export type FitmentTier = 
  | 'vin_verified' 
  | 'catalog_verified' 
  | 'oem_match' 
  | 'seller_confirmed' 
  | 'axon_suggested' 
  | 'unverified' 
  | 'incompatible'

export interface FitmentResult {
  isCompatible: boolean
  isGuaranteed: boolean
  label: string
  confidence: 'guaranteed' | 'likely' | 'unverified' | 'incompatible'
  tier?: FitmentTier
  tierLabel?: string
  score?: number
}

export function matchProductToVehicle(
  product: {
    make?: string
    model?: string
    year?: number | string
    name?: string
    title?: string
    sku?: string
    oemNumber?: string
    description?: string
    specifications?: Record<string, string>
  },
  vehicle: {
    make: string
    model: string
    year: number | string
    trim?: string
    engine?: string
    vin?: string
  } | null
): FitmentResult {
  if (!vehicle || !vehicle.make) {
    return {
      isCompatible: true,
      isGuaranteed: false,
      label: 'Universal Fitment - Select vehicle to verify',
      confidence: 'unverified',
      tier: 'unverified',
      tierLabel: 'Select Vehicle',
      score: 50
    }
  }

  const vMake = (vehicle.make || '').toLowerCase().trim()
  const vModel = (vehicle.model || '').toLowerCase().trim()
  const vYear = parseInt(String(vehicle.year || 0), 10)

  const pMake = (product.make || '').toLowerCase().trim()
  const pModel = (product.model || '').toLowerCase().trim()
  const pYear = parseInt(String(product.year || 0), 10)

  const fullText = `${product.title || ''} ${product.name || ''} ${product.description || ''} ${product.sku || ''} ${product.oemNumber || ''} ${JSON.stringify(product.specifications || {})}`.toLowerCase()

  let makeMatches = false
  if (!vMake || vMake === 'all makes') {
    makeMatches = true
  } else if (pMake) {
    makeMatches = pMake === vMake || pMake.startsWith(vMake) || vMake.startsWith(pMake)
  } else {
    const makeRegex = new RegExp(`(^|[^a-z0-9])${vMake}([^a-z0-9]|$)`, 'i')
    makeMatches = makeRegex.test(fullText)
  }

  let modelMatches = false
  if (!vModel || vModel === 'all models') {
    modelMatches = true
  } else if (pModel) {
    modelMatches = pModel === vModel || pModel.startsWith(vModel) || vModel.startsWith(pModel)
  } else {
    const modelRegex = new RegExp(`(^|[^a-z0-9])${vModel}([^a-z0-9]|$)`, 'i')
    modelMatches = modelRegex.test(fullText)
  }

  if (makeMatches && modelMatches) {
    let yearMatch = false
    if (pYear && vYear) {
      yearMatch = Math.abs(pYear - vYear) <= 4 || fullText.includes(String(vYear))
    } else if (vYear) {
      yearMatch = fullText.includes(String(vYear))
    } else {
      yearMatch = true
    }

    // Determine specific 5-tier fitment confidence
    let tier: FitmentTier = 'catalog_verified'
    let tierLabel = 'Catalog Verified'

    if (vehicle.vin && vehicle.vin.length === 17) {
      tier = 'vin_verified'
      tierLabel = 'VIN Verified (100% Exact)'
    } else if (product.oemNumber && product.oemNumber.length > 5) {
      tier = 'oem_match'
      tierLabel = `OEM Part Match (#${product.oemNumber})`
    } else if (yearMatch) {
      tier = 'catalog_verified'
      tierLabel = 'MMYTE Catalog Verified'
    } else {
      tier = 'axon_suggested'
      tierLabel = 'Axon Suggested Fit'
    }

    if (yearMatch) {
      let trimMatch = true
      if (vehicle.trim && vehicle.trim !== 'All Trims' && vehicle.trim !== 'Standard' && vehicle.trim !== 'custom') {
        const vTrim = vehicle.trim.toLowerCase().trim()
        const pTrim = (((product as any).trim || '') as string).toLowerCase().trim()
        if (pTrim && !pTrim.includes(vTrim) && !vTrim.includes(pTrim) && !fullText.includes(vTrim)) {
          trimMatch = false
        }
      }

      let engineMatch = true
      if (vehicle.engine && vehicle.engine !== 'All Engines' && vehicle.engine !== 'Engine' && vehicle.engine !== 'custom') {
        const vEngine = vehicle.engine.toLowerCase().trim()
        const pEngine = (((product as any).engine || '') as string).toLowerCase().trim()
        const displacementMatch = vEngine.match(/([0-9]+\.[0-9]+l?)/i)
        const disp = displacementMatch ? displacementMatch[1] : null
        if (pEngine && !pEngine.includes(vEngine) && !vEngine.includes(pEngine) && !(disp && fullText.includes(disp))) {
          engineMatch = false
        }
      }

      if (!trimMatch || !engineMatch) {
        return {
          isCompatible: false,
          isGuaranteed: false,
          label: `Not verified for specified trim/engine configuration`,
          confidence: 'incompatible',
          score: 15
        }
      }

      return {
        isCompatible: true,
        isGuaranteed: true,
        label: `Exact Fit for ${vehicle.year || ''} ${vehicle.make} ${vehicle.model}`,
        confidence: 'guaranteed',
        tier,
        tierLabel,
        score: tier === 'vin_verified' ? 100 : tier === 'oem_match' ? 95 : 90
      }
    }

    return {
      isCompatible: true,
      isGuaranteed: true,
      label: `Compatible with ${vehicle.make} ${vehicle.model}`,
      confidence: 'likely',
      tier: 'axon_suggested',
      tierLabel: 'Axon Suggested Fit',
      score: 80
    }
  }

  if (makeMatches && !modelMatches) {
    return {
      isCompatible: false,
      isGuaranteed: false,
      label: `Fits ${product.make || vehicle.make} (${product.model || 'Other Models'})`,
      confidence: 'incompatible',
      score: 25
    }
  }

  return {
    isCompatible: false,
    isGuaranteed: false,
    label: `Not verified for ${vehicle.year || ''} ${vehicle.make} ${vehicle.model}`,
    confidence: 'incompatible',
    score: 0
  }
}

export function checkFitmentCompatibility(
  product: {
    make?: string
    model?: string
    year?: number | string
    name?: string
    title?: string
    sku?: string
    description?: string
    specifications?: Record<string, string>
  },
  vehicle: {
    make: string
    model: string
    year: number | string
    trim?: string
    engine?: string
  } | null
): FitmentResult {
  return matchProductToVehicle(product, vehicle)
}

// ============================================================================
// NHTSA vPIC SUITE INTERFACES & CLIENT IMPLEMENTATIONS
// ============================================================================

const API_BASE_URL = process.env.NEXT_PUBLIC_P4D_URL || process.env.NEXT_PUBLIC_API_BASE_URL || 'https://parts4drive.com'

export interface NhtsaResponse<T> {
  success: boolean
  count?: number
  message?: string
  results?: T[]
  data?: T
  error?: string
}

export interface WMI {
  Country: string
  CreatedOn: string
  DateAvailableToPublic: string
  Id: number
  Name: string
  UpdatedOn: string
  URL: string
  VehicleType: string
  WMI: string
}

export interface Manufacturer {
  Country: string
  Mfr_CommonName: string
  Mfr_ID: number
  Mfr_Name: string
  VehicleTypes: any[]
}

export interface VehiclePart {
  Covered: string
  Description: string
  LetterDate: string
  ManufacturerId: number
  ManufacturerName: string
  ModelYearFrom: string
  ModelYearTo: string
  Name: string
  OrgId: number
  Type: string
  URL: string
}

export interface PlantCode {
  City: string
  Country: string
  DOTCode: string
  Name: string
  OldDOTCode: string
  PostalCode: string
  State: string
}

export interface VehicleVariable {
  DataType: string
  Description: string
  GroupName: string
  ID: number
  Name: string
}

export interface VehicleVariableValue {
  ElementName: string
  Id: number
  Name: string
}

async function safeFetchJson<T>(url: string): Promise<NhtsaResponse<T>> {
  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (err: any) {
    return { success: false, error: err.message, results: [] }
  }
}

// 1. Decode VIN (NHTSA + European ISO 3779)
export async function decodeVin(vin: string) {
  if (!vin) return { success: false, error: 'VIN is required' }
  return safeFetchJson<any>(`${API_BASE_URL}/api/v1/vehicles/decode-vin/${encodeURIComponent(vin)}`)
}

// 2. Get WMIs for Manufacturer
export async function getWMIsForManufacturer(manufacturer: string) {
  if (!manufacturer) return { success: false, error: 'Manufacturer is required' }
  return safeFetchJson<WMI>(`${API_BASE_URL}/api/v1/vehicles/wmis/${encodeURIComponent(manufacturer)}`)
}

// 3. Get All Makes
export async function getAllMakes() {
  const res = await safeFetchJson<{ Make_ID: number; Make_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/makes`)
  if (!res.results || res.results.length === 0) {
    return {
      success: true,
      results: GLOBAL_MAKES.map(m => ({ Make_ID: 0, Make_Name: m.name }))
    }
  }
  return res
}

// 4. Get Parts
export async function getParts(type = '', page = 1) {
  const qs = new URLSearchParams()
  if (type) qs.append('type', type)
  if (page) qs.append('page', String(page))
  return safeFetchJson<VehiclePart>(`${API_BASE_URL}/api/v1/vehicles/parts?${qs.toString()}`)
}

// 5. Get All Manufacturers
export async function getAllManufacturers(page = 1) {
  return safeFetchJson<Manufacturer>(`${API_BASE_URL}/api/v1/vehicles/manufacturers?page=${encodeURIComponent(page)}`)
}

// 6. Get Manufacturer Details
export async function getManufacturerDetails(manufacturer: string) {
  if (!manufacturer) return { success: false, error: 'Manufacturer is required' }
  return safeFetchJson<Manufacturer>(`${API_BASE_URL}/api/v1/vehicles/manufacturers/${encodeURIComponent(manufacturer)}`)
}

// 7. Get Makes for Manufacturer by Manufacturer Name
export async function getMakesForManufacturer(manufacturer: string) {
  if (!manufacturer) return { success: false, error: 'Manufacturer is required' }
  return safeFetchJson<{ Make_ID: number; Make_Name: string; Mfr_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/makes-for-manufacturer/${encodeURIComponent(manufacturer)}`)
}

// 8. Get Makes for Manufacturer by Manufacturer Name and Year
export async function getMakesForManufacturerAndYear(manufacturer: string, year?: number | string) {
  if (!manufacturer) return { success: false, error: 'Manufacturer is required' }
  const targetYear = year || new Date().getFullYear()
  return safeFetchJson<{ Make_ID: number; Make_Name: string; Mfr_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/makes-for-manufacturer/${encodeURIComponent(manufacturer)}/year/${encodeURIComponent(targetYear)}`)
}

// 9. Get Makes for Vehicle Type by Vehicle Type Name
export async function getMakesForVehicleType(vehicleType: string) {
  if (!vehicleType) return { success: false, error: 'Vehicle type is required' }
  return safeFetchJson<{ MakeId: number; MakeName: string; VehicleTypeId: number; VehicleTypeName: string }>(`${API_BASE_URL}/api/v1/vehicles/makes-for-type/${encodeURIComponent(vehicleType)}`)
}

// 10. Get Vehicle Types for Make by Name
export async function getVehicleTypesForMake(make: string) {
  if (!make) return { success: false, error: 'Vehicle make is required' }
  return safeFetchJson<{ VehicleTypeId: number; VehicleTypeName: string }>(`${API_BASE_URL}/api/v1/vehicles/types-for-make/${encodeURIComponent(make)}`)
}

// 11. Get Vehicle Types for Make by Id
export async function getVehicleTypesForMakeId(makeId: number | string) {
  if (!makeId) return { success: false, error: 'Vehicle make ID is required' }
  return safeFetchJson<{ VehicleTypeId: number; VehicleTypeName: string }>(`${API_BASE_URL}/api/v1/vehicles/types-for-make-id/${encodeURIComponent(makeId)}`)
}

// 12. Get Equipment Plant Codes
export async function getEquipmentPlantCodes(options: { year?: number; equipmentType?: number; reportType?: string } = {}) {
  const qs = new URLSearchParams({
    year: String(options.year || 2020),
    equipmentType: String(options.equipmentType || 1),
    reportType: options.reportType || 'All'
  })
  return safeFetchJson<PlantCode>(`${API_BASE_URL}/api/v1/vehicles/plant-codes?${qs.toString()}`)
}

// 13. Get Models for Make
export async function getModelsForMake(make: string) {
  if (!make) return { success: false, error: 'Vehicle make is required' }
  const res = await safeFetchJson<{ Model_ID: number; Model_Name: string; Make_ID: number; Make_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/models/${encodeURIComponent(make)}`)
  if (!res.data && !res.results) {
    const found = GLOBAL_MAKES.find(m => m.name.toLowerCase() === make.toLowerCase() || m.id.toLowerCase() === make.toLowerCase())
    if (found) {
      return { success: true, make, data: found.models }
    }
  }
  return res
}

// 14. Get Models for MakeId
export async function getModelsForMakeId(makeId: number | string) {
  if (!makeId) return { success: false, error: 'Vehicle make ID is required' }
  return safeFetchJson<{ Model_ID: number; Model_Name: string; Make_ID: number; Make_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/models-by-id/${encodeURIComponent(makeId)}`)
}

// 15. Get Models for Make and a combination of Year and Vehicle Type
export async function getModelsForMakeYearType(make: string, year?: number | string, vehicleType?: string) {
  if (!make) return { success: false, error: 'Vehicle make is required' }
  const qs = new URLSearchParams({ make })
  if (year) qs.append('year', String(year))
  if (vehicleType) qs.append('vehicleType', vehicleType)
  return safeFetchJson<{ Model_ID: number; Model_Name: string; Make_ID: number; Make_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/models-by-year-type?${qs.toString()}`)
}

// 16. Get Models for Make Id and a combination of Year and Vehicle Type
export async function getModelsForMakeIdYearType(makeId: number | string, year?: number | string, vehicleType?: string) {
  if (!makeId) return { success: false, error: 'Vehicle make ID is required' }
  const qs = new URLSearchParams({ makeId: String(makeId) })
  if (year) qs.append('year', String(year))
  if (vehicleType) qs.append('vehicleType', vehicleType)
  return safeFetchJson<{ Model_ID: number; Model_Name: string; Make_ID: number; Make_Name: string }>(`${API_BASE_URL}/api/v1/vehicles/models-by-id-year-type?${qs.toString()}`)
}

// 17. Get Vehicle Variables List
export async function getVehicleVariablesList() {
  return safeFetchJson<VehicleVariable>(`${API_BASE_URL}/api/v1/vehicles/variables`)
}

// 18. Get Vehicle Variable Values List
export async function getVehicleVariableValuesList(variable: string) {
  if (!variable) return { success: false, error: 'Vehicle variable name or ID is required' }
  return safeFetchJson<VehicleVariableValue>(`${API_BASE_URL}/api/v1/vehicles/variables/${encodeURIComponent(variable)}/values`)
}

// Server-side vehicle fitment check
export async function checkFitmentOnServer(product: any, vehicle: any): Promise<FitmentResult> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/v1/vehicles/fitment-check`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product, vehicle })
    })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (err) {
    return matchProductToVehicle(product, vehicle)
  }
}

// Auto-generated AI Parts Specialist Note generator (MMYTE & Component Aligned)
export function generatePartsSpecialistNote(product: any = {}): string {
  const category = String(product.category || product.mmyt_category || '').toUpperCase()
  const subcategory = String(product.subcategory || product.mmyt_subcategory || '').toLowerCase()
  const name = String(product.name || product.title || '').toLowerCase()
  const make = product.make || product.mmyt_make || ''
  const model = product.model || product.mmyt_model || ''
  const vehicleStr = [make, model].filter(Boolean).join(' ')
  const vehicleRef = vehicleStr ? ` for your ${vehicleStr}` : ''
  const pos = product.position || product.side || product.sideLabel || ''
  const posRef = pos && pos !== 'none' ? ` (${pos})` : ''

  if (category.includes('BRAK') || subcategory.includes('brake') || subcategory.includes('pad') || subcategory.includes('rotor') || subcategory.includes('disc') || name.includes('brake') || name.includes('pad')) {
    return `Clean rotor surfaces with brake cleaner before pad installation${vehicleRef}. Apply anti-squeal ceramic lubricant strictly to the caliper carrier slide pins and backing plate ears—never allow grease onto the friction lining. Complete a 200-mile gentle bedding-in cycle to establish an even friction boundary layer and prevent brake shudder. Torque lug nuts in a criss-cross pattern to OEM spec (103–120 Nm).`
  }

  if (category.includes('FILTR') || subcategory.includes('filter') || name.includes('filter')) {
    return `Verify the old rubber seal is removed from the engine mounting surface before fitting the new unit${vehicleRef}. Lightly coat the new nitrile gasket with fresh motor oil and hand-tighten until initial contact plus 3/4 turn. Always renew the sump drain plug crush washer and torque to factory spec (35–42 Nm) to prevent oil pan stripping.`
  }

  if (category.includes('SUSP') || category.includes('STEER') || subcategory.includes('arm') || subcategory.includes('shock') || subcategory.includes('strut') || subcategory.includes('bushing') || subcategory.includes('joint') || subcategory.includes('link') || name.includes('arm') || name.includes('shock') || name.includes('strut')) {
    return `CRITICAL INSTALLATION REQUIREMENT: Always torque all suspension mounting bolts, control arm bushings, and stabilizer links with the vehicle resting at normal ride height under full curb weight${vehicleRef}—never tighten in the air on a lift, as pre-loading causes immediate bushing tear. A full 4-wheel computerized laser alignment is mandatory after installation.`
  }

  if (category.includes('COOL') || subcategory.includes('radiator') || subcategory.includes('pump') || subcategory.includes('thermostat') || name.includes('radiator') || name.includes('water pump')) {
    return `Refill exclusively with 50/50 ethylene glycol OAT/HOAT coolant conforming to OEM chemical formulations${vehicleRef}. Use a spill-free funnel kit to vacuum-bleed air pockets from heater cores and upper radiator passages to prevent thermal hot spots and water pump cavitation. Torque water pump fasteners in a cross pattern to 10–14 Nm.`
  }

  if (category.includes('IGNIT') || subcategory.includes('plug') || subcategory.includes('coil') || name.includes('spark plug') || name.includes('coil')) {
    return `Verify electrode gap matches manufacturer specifications before installation${vehicleRef}. Thread spark plugs by hand to avoid cross-threading aluminum cylinder heads, then torque strictly to 18–22 Nm. Coat inner ignition coil boots with high-dielectric silicone grease to repel moisture and stop high-voltage tracking.`
  }

  if (category.includes('ELECTR') || subcategory.includes('alternator') || subcategory.includes('starter') || subcategory.includes('sensor') || name.includes('alternator') || name.includes('starter')) {
    return `Disconnect negative battery terminal before unbolting B+ battery leads${vehicleRef}. Verify battery resting voltage is ≥12.6V prior to alternator installation to prevent diode pack overload. Ensure drive belt tensioner indicator marks align within factory limits (10–12 mm belt deflection under 100N pressure).`
  }

  if (category.includes('TRANS') || subcategory.includes('clutch') || subcategory.includes('axle') || subcategory.includes('gear') || name.includes('clutch') || name.includes('gearbox')) {
    return `Center the friction plate with a precision clutch alignment tool before tightening pressure plate bolts in a star sequence to 25–30 Nm${vehicleRef}. Lightly coat input shaft splines with high-temp urea grease and wipe clean any excess. Always install new differential axle seals when replacing CV half-shafts.`
  }

  if (category.includes('BODY') || subcategory.includes('bumper') || subcategory.includes('fender') || subcategory.includes('grille') || subcategory.includes('mirror') || name.includes('bumper') || name.includes('fender')) {
    return `Dry-fit all mounting brackets, locator pins, and fastener clips prior to final bolt torquing${vehicleRef}${posRef}. Ensure uniform panel gaps of 3.5–4.5 mm with adjoining hood and fender sheet metal. Transfer all ultrasonic parking sensors, radar brackets, and harness retainers firmly.`
  }

  if (category.includes('EXHAUST') || subcategory.includes('muffler') || subcategory.includes('catalytic') || subcategory.includes('pipe') || name.includes('exhaust') || name.includes('catalytic')) {
    return `Apply high-temperature copper anti-seize exclusively to sensor and flange threads${vehicleRef}. Replace all multi-layer steel exhaust flange gaskets and torque oxygen sensors to 40–45 Nm without contaminating sensor ceramic tips.`
  }

  return `Precision replacement component meeting or exceeding OEM tolerances${vehicleRef}${posRef}. 1:1 bolt-on fitment without harness or bracket modifications. Always verify vehicle VIN and car specifications prior to final installation.`
}


export interface PartKeywordDefinition {
  keywords: string
  category: string
  subcategory: string
  part: string
}

export const PART_KEYWORDS: PartKeywordDefinition[] = [
  {
    "keywords": "headlight,head lamp,headlight assembly,led headlight,head lights,headlamp,headlamps,headlight housing,hid headlight,xenon headlight",
    "category": "LIGHTING",
    "subcategory": "Headlights",
    "part": "Headlight Assembly"
  },
  {
    "keywords": "tail light,rear light,tail lamp,taillight,tail lights,rear lamp,rear lights,back light,back lights,tail lamp assembly",
    "category": "LIGHTING",
    "subcategory": "Tail Lights",
    "part": "Tail Light Assembly"
  },
  {
    "keywords": "fog light,fog lamp,fog lights,fog lamps,foglight,foglamp,fog light kit",
    "category": "LIGHTING",
    "subcategory": "Fog Lights",
    "part": "Fog Light"
  },
  {
    "keywords": "indicator,side indicator,turn signal,turn light,blinker,turn signal switch,combination switch",
    "category": "LIGHTING",
    "subcategory": "Indicators",
    "part": "Side Indicator"
  },
  {
    "keywords": "brake light,stop light,brake lights,third brake light,chmsl,brake light bulb",
    "category": "LIGHTING",
    "subcategory": "Brake Lights",
    "part": "Brake Light"
  },
  {
    "keywords": "reverse light,backup light,reverse lamp,backup lamp",
    "category": "LIGHTING",
    "subcategory": "Reverse Lights",
    "part": "Reverse Light"
  },
  {
    "keywords": "license plate light,number plate light,plate lamp,license lamp applique",
    "category": "LIGHTING",
    "subcategory": "License Plate Lights",
    "part": "License Plate Light"
  },
  {
    "keywords": "side marker,marker light,side marker light,side marker lamp",
    "category": "LIGHTING",
    "subcategory": "Side Markers",
    "part": "Side Marker"
  },
  {
    "keywords": "interior light,dome light,map light,courtesy light,footwell light,ceiling light,indoor light",
    "category": "LIGHTING",
    "subcategory": "Interior Lights",
    "part": "Interior Light"
  },
  {
    "keywords": "drl,daytime running light,daytime running lamp",
    "category": "LIGHTING",
    "subcategory": "Daytime Running Lights",
    "part": "Daytime Running Light"
  },
  {
    "keywords": "hid kit,hid ballast,xenon kit,xenon bulb,hid bulb",
    "category": "LIGHTING",
    "subcategory": "HID Kits",
    "part": "HID Kit"
  },
  {
    "keywords": "led bulb,led kit,led light bar,led bulb kit,decorative light",
    "category": "LIGHTING",
    "subcategory": "LED Bulbs",
    "part": "LED Bulb"
  },
  {
    "keywords": "halogen bulb,headlight bulb,indicator bulb,festoon bulb,bulb,instrument light,indicator light,searchlight,front turn signal,side turn light,rear combination light",
    "category": "LIGHTING",
    "subcategory": "Halogen Bulbs",
    "part": "Halogen Bulb"
  },
  {
    "keywords": "brake pad,brake pads,pads,break pad,break pads,pad set,brake pad set,front brake pads,rear brake pads,brake pad shim,abutment clip",
    "category": "BRAKING",
    "subcategory": "Brake Pads",
    "part": "Brake Pad Set"
  },
  {
    "keywords": "brake rotor,rotor,rotors,disc rotor,brake disc,brake discs,brake disk,break disc,brake disks,disc brake,disk brake,brake rotor disc,brake disc rotor",
    "category": "BRAKING",
    "subcategory": "Brake Discs",
    "part": "Brake Disc"
  },
  {
    "keywords": "brake drum,drum,drums,brake drums,rear brake drum",
    "category": "BRAKING",
    "subcategory": "Brake Drums",
    "part": "Brake Drum"
  },
  {
    "keywords": "brake caliper,caliper,calipers,brake calipers,front caliper,rear caliper,caliper bracket,caliper slide pin,caliper pin boot",
    "category": "BRAKING",
    "subcategory": "Brake Calipers",
    "part": "Brake Caliper"
  },
  {
    "keywords": "brake master cylinder,master cylinder,brake cylinder,master brake cylinder,brake master",
    "category": "BRAKING",
    "subcategory": "Master Cylinders",
    "part": "Brake Master Cylinder"
  },
  {
    "keywords": "brake shoe,brake shoes,brake lining,brake linings,wheel cylinder,drum brake hardware kit,brake spring kit,brake adjuster,brake shoe retainer",
    "category": "BRAKING",
    "subcategory": "Brake Shoes",
    "part": "Brake Shoe"
  },
  {
    "keywords": "brake booster,brake servo,vacuum booster,power brake booster",
    "category": "BRAKING",
    "subcategory": "Brake Boosters",
    "part": "Brake Booster"
  },
  {
    "keywords": "brake hose,brake hoses,brake line,brake lines,brake hose kit,brake pipe",
    "category": "BRAKING",
    "subcategory": "Brake Hoses",
    "part": "Brake Hose"
  },
  {
    "keywords": "abs sensor,abs wheel speed sensor,wheel speed sensor,abs sensor front,abs sensor rear",
    "category": "BRAKING",
    "subcategory": "ABS Sensors",
    "part": "ABS Sensor"
  },
  {
    "keywords": "abs module,abs pump,abs control module,abs unit,abs accumulator,traction control module,brake pressure sensor,yaw rate sensor",
    "category": "BRAKING",
    "subcategory": "ABS Modules",
    "part": "ABS Module"
  },
  {
    "keywords": "parking brake,handbrake,e-brake,parking brake shoe,parking brake motor,parking brake cable,parking brake lever,parking brake actuator",
    "category": "BRAKING",
    "subcategory": "Parking Brakes",
    "part": "Parking Brake"
  },
  {
    "keywords": "brake pad wear sensor,wear sensor,brake wear sensor,brake sensor,brake light switch",
    "category": "BRAKING",
    "subcategory": "Brake Wear Sensors",
    "part": "Brake Wear Sensor"
  },
  {
    "keywords": "brake pedal,brake pedal assembly,brake distribution valve,brake cooling duct",
    "category": "BRAKING",
    "subcategory": "Brake Pedals",
    "part": "Brake Pedal Assembly"
  },
  {
    "keywords": "oil filter,engine oil filter,oil filters,spin on filter,cartridge oil filter",
    "category": "FILTRATION",
    "subcategory": "Oil Filters",
    "part": "Oil Filter"
  },
  {
    "keywords": "air filter,engine air filter,air filters,air cleaner,panel filter,air filter element,air cleaner element",
    "category": "FILTRATION",
    "subcategory": "Air Filters",
    "part": "Air Filter"
  },
  {
    "keywords": "fuel filter,fuel filters,petrol filter,diesel filter,water separator",
    "category": "FILTRATION",
    "subcategory": "Fuel Filters",
    "part": "Fuel Filter"
  },
  {
    "keywords": "cabin filter,pollen filter,ac filter,cabin air filter,interior filter,hepa cabin filter",
    "category": "FILTRATION",
    "subcategory": "Cabin Filters",
    "part": "Cabin Filter"
  },
  {
    "keywords": "transmission filter,gearbox filter,atf filter,cvt filter",
    "category": "FILTRATION",
    "subcategory": "Transmission Filters",
    "part": "Transmission Filter"
  },
  {
    "keywords": "diesel filter,water separator filter,diesel particulate",
    "category": "FILTRATION",
    "subcategory": "Diesel Filters",
    "part": "Diesel Filter"
  },
  {
    "keywords": "spark plug,spark plugs,iridium spark plug,plug,plugs,iridium plug,platinum plug,spark plug set,double platinum plug",
    "category": "IGNITION",
    "subcategory": "Spark Plugs",
    "part": "Spark Plug"
  },
  {
    "keywords": "ignition coil,coil pack,coil,coils,ignition coils,distributor coil,ign coil,coil on plug,cop coil,coil packs",
    "category": "IGNITION",
    "subcategory": "Ignition Coils",
    "part": "Ignition Coil"
  },
  {
    "keywords": "distributor cap,distributor rotor,cap and rotor,distributor,dist cap,distributor assembly",
    "category": "IGNITION",
    "subcategory": "Distributors",
    "part": "Distributor"
  },
  {
    "keywords": "ignition module,ignition control module,icm,igniter,ignition box",
    "category": "IGNITION",
    "subcategory": "Ignition Modules",
    "part": "Ignition Module"
  },
  {
    "keywords": "glow plug,glow plugs,diesel glow plug,glow plug set",
    "category": "IGNITION",
    "subcategory": "Glow Plugs",
    "part": "Glow Plug"
  },
  {
    "keywords": "spark plug wire,spark plug wires,plug wire,ignition wire,ht lead,ignition lead,spark plug cable",
    "category": "IGNITION",
    "subcategory": "Spark Plug Wires",
    "part": "Spark Plug Wire"
  },
  {
    "keywords": "ignition switch,ignition lock,ignition cylinder,ignition barrel,ignition lock cylinder",
    "category": "IGNITION",
    "subcategory": "Ignition Switches",
    "part": "Ignition Switch"
  },
  {
    "keywords": "shock absorber,shock,absorber,damper,shocks,shock absorbers,gas shock,front shock,rear shock",
    "category": "SUSPENSION",
    "subcategory": "Shock Absorbers",
    "part": "Shock Absorber"
  },
  {
    "keywords": "control arm,lower arm,upper arm,lower control arm,upper control arm,wishbone,front control arm,rear control arm,control arm bushing",
    "category": "SUSPENSION",
    "subcategory": "Control Arms",
    "part": "Control Arm"
  },
  {
    "keywords": "ball joint,ball joints,lower ball joint,upper ball joint",
    "category": "SUSPENSION",
    "subcategory": "Ball Joints",
    "part": "Ball Joint"
  },
  {
    "keywords": "tie rod end,tie rod,tie rods,outer tie rod,inner tie rod,track rod end,tie rod assembly",
    "category": "SUSPENSION",
    "subcategory": "Tie Rod Ends",
    "part": "Tie Rod End"
  },
  {
    "keywords": "stabilizer link,sway bar link,anti roll bar link,stabilizer bar link,anti-roll bar link,drop link,sway bar end link",
    "category": "SUSPENSION",
    "subcategory": "Stabilizer Links",
    "part": "Stabilizer Link"
  },
  {
    "keywords": "sway bar,stabilizer bar,anti roll bar,anti-roll bar,sway bar assembly",
    "category": "SUSPENSION",
    "subcategory": "Sway Bars",
    "part": "Sway Bar"
  },
  {
    "keywords": "sway bar bushing,stabilizer bushing,anti roll bar bushing,sway bar bushings",
    "category": "SUSPENSION",
    "subcategory": "Sway Bar Bushings",
    "part": "Sway Bar Bushing"
  },
  {
    "keywords": "strut,strut assembly,strut mount,coilover,front strut,rear strut,complete strut,quick strut,strut mount bearing",
    "category": "SUSPENSION",
    "subcategory": "Struts",
    "part": "Strut Assembly"
  },
  {
    "keywords": "coil spring,suspension spring,spring,coil springs,front spring,rear spring,spring insulator,spring seat",
    "category": "SUSPENSION",
    "subcategory": "Coil Springs",
    "part": "Coil Spring"
  },
  {
    "keywords": "leaf spring,leaf springs,rear leaf spring,leaf spring bushing,spring shackle",
    "category": "SUSPENSION",
    "subcategory": "Leaf Springs",
    "part": "Leaf Spring"
  },
  {
    "keywords": "wheel bearing,hub bearing,wheel hub bearing,hub assembly,wheel bearing kit,axle bearing,axle seal,wheel seal",
    "category": "SUSPENSION",
    "subcategory": "Wheel Bearings",
    "part": "Wheel Bearing"
  },
  {
    "keywords": "wheel hub,hub,front hub,rear hub,wheel hub assembly",
    "category": "SUSPENSION",
    "subcategory": "Wheel Hubs",
    "part": "Wheel Hub"
  },
  {
    "keywords": "bush,bushing,bushings,control arm bush,suspension bush,rubber bush,control arm bushing,suspension bushing",
    "category": "SUSPENSION",
    "subcategory": "Bushings",
    "part": "Bushing"
  },
  {
    "keywords": "strut mount,shock mount,top mount,strut bearing,strut mount bearing,strut mount kit,damper mount,damper mounting",
    "category": "SUSPENSION",
    "subcategory": "Strut Mounts",
    "part": "Strut Mount"
  },
  {
    "keywords": "air suspension,air spring,air strut,air bag suspension,air suspension strut,air suspension compressor,ride height sensor",
    "category": "SUSPENSION",
    "subcategory": "Air Suspension",
    "part": "Air Suspension Unit"
  },
  {
    "keywords": "trailing arm,lateral link,panhard rod,swing arm",
    "category": "SUSPENSION",
    "subcategory": "Trailing Arms",
    "part": "Trailing Arm"
  },
  {
    "keywords": "steering rack,rack and pinion,power steering rack,steering box,power steering box,steering gear",
    "category": "STEERING",
    "subcategory": "Steering Racks",
    "part": "Steering Rack"
  },
  {
    "keywords": "power steering pump,steering pump,pas pump,steering pump assembly",
    "category": "STEERING",
    "subcategory": "Power Steering Pumps",
    "part": "Power Steering Pump"
  },
  {
    "keywords": "steering column,steering shaft,steering column assembly,steering column switch,steering wheel lock",
    "category": "STEERING",
    "subcategory": "Steering Columns",
    "part": "Steering Column"
  },
  {
    "keywords": "steering knuckle,spindle,steering knuckle assembly,front knuckle",
    "category": "STEERING",
    "subcategory": "Steering Knuckles",
    "part": "Steering Knuckle"
  },
  {
    "keywords": "power steering hose,power steering fluid,steering damper,idler arm,pitman arm,center rod assembly,drag link,main pin,kingpin",
    "category": "STEERING",
    "subcategory": "Steering Linkage",
    "part": "Steering Linkage"
  },
  {
    "keywords": "timing belt,timing chain,timing kit,timing set,cam belt,cam chain,timing belt kit,timing chain kit,timing belt tensioner,timing chain tensioner,timing gear",
    "category": "ENGINE",
    "subcategory": "Timing Kits",
    "part": "Timing Kit"
  },
  {
    "keywords": "water pump,coolant pump,water pump assembly,auxiliary water pump,water pump gasket",
    "category": "ENGINE",
    "subcategory": "Water Pumps",
    "part": "Water Pump"
  },
  {
    "keywords": "engine mount,engine mounting,motor mount,motor mounting,engine mount kit,engine mounting bracket",
    "category": "ENGINE",
    "subcategory": "Engine Mounts",
    "part": "Engine Mount"
  },
  {
    "keywords": "thermostat,engine thermostat,coolant thermostat,thermostat housing,thermostat kit",
    "category": "ENGINE",
    "subcategory": "Thermostats",
    "part": "Thermostat"
  },
  {
    "keywords": "head gasket,cylinder head gasket,engine head gasket,gasket,gasket set,head gasket set,cylinder head gasket",
    "category": "ENGINE",
    "subcategory": "Gaskets",
    "part": "Head Gasket"
  },
  {
    "keywords": "piston ring,piston rings,engine piston,piston,piston kit,piston set,piston ring set,compression ring,oil ring,wrist pin,piston pin",
    "category": "ENGINE",
    "subcategory": "Pistons",
    "part": "Piston"
  },
  {
    "keywords": "camshaft,cam shaft,cam,camshaft kit,performance camshaft,camshaft bearing,camshaft phaser",
    "category": "ENGINE",
    "subcategory": "Camshafts",
    "part": "Camshaft"
  },
  {
    "keywords": "crankshaft,crank shaft,crank,crankshaft pulley,crankshaft kit,crankshaft bearing shell,crankshaft bush",
    "category": "ENGINE",
    "subcategory": "Crankshafts",
    "part": "Crankshaft"
  },
  {
    "keywords": "valve cover,rocker cover,cam cover,valve cover gasket,valve cover assembly",
    "category": "ENGINE",
    "subcategory": "Valve Covers",
    "part": "Valve Cover"
  },
  {
    "keywords": "oil pump,engine oil pump,oil pump assembly,oil pump kit,oil pickup tube",
    "category": "ENGINE",
    "subcategory": "Oil Pumps",
    "part": "Oil Pump"
  },
  {
    "keywords": "oil pan,oil sump,oil pan gasket,engine oil pan,oil pan drain plug",
    "category": "ENGINE",
    "subcategory": "Oil Pans",
    "part": "Oil Pan"
  },
  {
    "keywords": "cylinder head,cylinder head assembly,head,engine head,cylinder head kit",
    "category": "ENGINE",
    "subcategory": "Cylinder Heads",
    "part": "Cylinder Head"
  },
  {
    "keywords": "valve,valves,intake valve,exhaust valve,engine valve,valve kit",
    "category": "ENGINE",
    "subcategory": "Valves",
    "part": "Engine Valve"
  },
  {
    "keywords": "valve stem seal,valve seal,valve guide,valve spring,valve springs",
    "category": "ENGINE",
    "subcategory": "Valve Seals",
    "part": "Valve Seal"
  },
  {
    "keywords": "rocker arm,rocker arms,rocker arm assembly,rocker arm shaft",
    "category": "ENGINE",
    "subcategory": "Rocker Arms",
    "part": "Rocker Arm"
  },
  {
    "keywords": "lifter,lifters,hydraulic lifter,tappet,tappets,hydraulic tappet,valve lifter",
    "category": "ENGINE",
    "subcategory": "Lifters",
    "part": "Lifter"
  },
  {
    "keywords": "pushrod,pushrods,push rod,push rods",
    "category": "ENGINE",
    "subcategory": "Pushrods",
    "part": "Pushrod"
  },
  {
    "keywords": "intake manifold,inlet manifold,intake manifold assembly,intake manifold gasket,intake resonator",
    "category": "ENGINE",
    "subcategory": "Intake Manifolds",
    "part": "Intake Manifold"
  },
  {
    "keywords": "exhaust manifold,exhaust headers,header,headers,exhaust manifold assembly,exhaust manifold gasket",
    "category": "ENGINE",
    "subcategory": "Exhaust Manifolds",
    "part": "Exhaust Manifold"
  },
  {
    "keywords": "turbo,turbocharger,turbo charger,turbo kit,performance turbo,turbocharger oil line",
    "category": "ENGINE",
    "subcategory": "Turbos",
    "part": "Turbocharger"
  },
  {
    "keywords": "supercharger,supercharger kit,blower,roots blower",
    "category": "ENGINE",
    "subcategory": "Superchargers",
    "part": "Supercharger"
  },
  {
    "keywords": "wastegate,waste gate,turbo wastegate,wastegate actuator",
    "category": "ENGINE",
    "subcategory": "Wastegates",
    "part": "Wastegate"
  },
  {
    "keywords": "blow off valve,bov,diverter valve,dump valve,recirculation valve",
    "category": "ENGINE",
    "subcategory": "Blow Off Valves",
    "part": "Blow Off Valve"
  },
  {
    "keywords": "pcv valve,pcv,crankcase valve,positive crankcase ventilation valve,crankcase ventilation valve",
    "category": "ENGINE",
    "subcategory": "PCV Valves",
    "part": "PCV Valve"
  },
  {
    "keywords": "egr valve,egr,exhaust gas recirculation valve,egr valve assembly,egr cooler",
    "category": "ENGINE",
    "subcategory": "EGR Valves",
    "part": "EGR Valve"
  },
  {
    "keywords": "vvt solenoid,vvt valve,variable valve timing solenoid,vvt oil control valve",
    "category": "ENGINE",
    "subcategory": "VVT Solenoids",
    "part": "VVT Solenoid"
  },
  {
    "keywords": "iac valve,idle air control valve,idle control valve,iac,idle air control",
    "category": "ENGINE",
    "subcategory": "Idle Air Control Valves",
    "part": "Idle Air Control Valve"
  },
  {
    "keywords": "balance shaft,balance shafts,balance shaft assembly,balance weight,steel plate",
    "category": "ENGINE",
    "subcategory": "Balance Shafts",
    "part": "Balance Shaft"
  },
  {
    "keywords": "engine block,short block,long block,crate engine,engine assembly,used engine,cylinder block,crankcase,cylinder liner,engine block bracket,main bearing cap,main bearing",
    "category": "ENGINE",
    "subcategory": "Engine Blocks",
    "part": "Engine Block"
  },
  {
    "keywords": "flywheel,flywheels,flexplate,flexplates,dual mass flywheel",
    "category": "ENGINE",
    "subcategory": "Flywheels",
    "part": "Flywheel"
  },
  {
    "keywords": "harmonic balancer,crank pulley,harmonic damper,balancer",
    "category": "ENGINE",
    "subcategory": "Harmonic Balancers",
    "part": "Harmonic Balancer"
  },
  {
    "keywords": "seal,seals,oil seal,crank seal,rear main seal,front crank seal,cam seal,oil seal",
    "category": "ENGINE",
    "subcategory": "Seals",
    "part": "Seal"
  },
  {
    "keywords": "o-ring,o ring,o-rings,oil o-ring,oring",
    "category": "ENGINE",
    "subcategory": "O-Rings",
    "part": "O-Ring"
  },
  {
    "keywords": "connecting rod,connecting rods,con rod,connecting rod bearing shell,connecting rod bush",
    "category": "ENGINE",
    "subcategory": "Connecting Rods",
    "part": "Connecting Rod"
  },
  {
    "keywords": "drive belt,serpentine belt,v-belt,accessory belt,belt,drive belts,auxiliary belt",
    "category": "ENGINE",
    "subcategory": "Drive Belts",
    "part": "Drive Belt"
  },
  {
    "keywords": "belt tensioner,serpentine belt tensioner,drive belt tensioner,automatic tensioner",
    "category": "ENGINE",
    "subcategory": "Belt Tensioners",
    "part": "Belt Tensioner"
  },
  {
    "keywords": "idler pulley,idler pulleys,pulley,tensioner pulley",
    "category": "ENGINE",
    "subcategory": "Idler Pulleys",
    "part": "Idler Pulley"
  },
  {
    "keywords": "vacuum pump,vacuum pumps,brake vacuum pump",
    "category": "ENGINE",
    "subcategory": "Vacuum Pumps",
    "part": "Vacuum Pump"
  },
  {
    "keywords": "secondary air pump,air pump,secondary air injection",
    "category": "ENGINE",
    "subcategory": "Secondary Air Pumps",
    "part": "Secondary Air Pump"
  },
  {
    "keywords": "oil pressure regulator,oil pressure relief valve,oil regulator",
    "category": "ENGINE",
    "subcategory": "Oil Pressure Regulators",
    "part": "Oil Pressure Regulator"
  },
  {
    "keywords": "alternator,charging unit,generator,charging alternator,alternator assembly,voltage regulator",
    "category": "ELECTRICAL",
    "subcategory": "Alternators",
    "part": "Alternator"
  },
  {
    "keywords": "starter motor,starter,starting motor,starter solenoid,starter assembly,neutral safety switch",
    "category": "ELECTRICAL",
    "subcategory": "Starters",
    "part": "Starter Motor"
  },
  {
    "keywords": "battery,car battery,agm battery,lead acid battery,start stop battery,battery terminal,battery cable,battery tray,battery hold-down,battery cap,battery control system,battery plate,battery box",
    "category": "ELECTRICAL",
    "subcategory": "Batteries",
    "part": "Battery"
  },
  {
    "keywords": "oxygen sensor,o2 sensor,lambda sensor,air fuel ratio sensor,upstream o2 sensor,downstream o2 sensor",
    "category": "ELECTRICAL",
    "subcategory": "Oxygen Sensors",
    "part": "Oxygen Sensor"
  },
  {
    "keywords": "maf sensor,mass air flow sensor,mass airflow sensor,air flow meter",
    "category": "ELECTRICAL",
    "subcategory": "MAF Sensors",
    "part": "MAF Sensor"
  },
  {
    "keywords": "map sensor,manifold absolute pressure sensor,boost sensor,intake air pressure sensor",
    "category": "ELECTRICAL",
    "subcategory": "MAP Sensors",
    "part": "MAP Sensor"
  },
  {
    "keywords": "tps sensor,throttle position sensor,throttle sensor",
    "category": "ELECTRICAL",
    "subcategory": "TPS Sensors",
    "part": "TPS Sensor"
  },
  {
    "keywords": "iat sensor,intake air temperature sensor,air temp sensor",
    "category": "ELECTRICAL",
    "subcategory": "IAT Sensors",
    "part": "IAT Sensor"
  },
  {
    "keywords": "ect sensor,engine coolant temperature sensor,coolant temp sensor,water temp sensor,coolant temperature sensor",
    "category": "ELECTRICAL",
    "subcategory": "ECT Sensors",
    "part": "ECT Sensor"
  },
  {
    "keywords": "ckp sensor,crankshaft position sensor,crank sensor,crank position sensor",
    "category": "ELECTRICAL",
    "subcategory": "Crankshaft Position Sensors",
    "part": "Crankshaft Position Sensor"
  },
  {
    "keywords": "cmp sensor,camshaft position sensor,cam sensor,cam position sensor",
    "category": "ELECTRICAL",
    "subcategory": "Camshaft Position Sensors",
    "part": "Camshaft Position Sensor"
  },
  {
    "keywords": "vss sensor,vehicle speed sensor,speed sensor,speedometer sensor",
    "category": "ELECTRICAL",
    "subcategory": "Speed Sensors",
    "part": "Speed Sensor"
  },
  {
    "keywords": "knock sensor,knock sensors,detonation sensor",
    "category": "ELECTRICAL",
    "subcategory": "Knock Sensors",
    "part": "Knock Sensor"
  },
  {
    "keywords": "oil pressure sensor,oil pressure switch,oil pressure sender,oil level sensor",
    "category": "ELECTRICAL",
    "subcategory": "Oil Pressure Sensors",
    "part": "Oil Pressure Sensor"
  },
  {
    "keywords": "fuel level sensor,sending unit,fuel gauge sender,fuel sender unit",
    "category": "ELECTRICAL",
    "subcategory": "Fuel Level Sensors",
    "part": "Fuel Level Sensor"
  },
  {
    "keywords": "tpms sensor,tire pressure sensor,tire pressure monitoring sensor",
    "category": "ELECTRICAL",
    "subcategory": "TPMS Sensors",
    "part": "TPMS Sensor"
  },
  {
    "keywords": "parking sensor,pdc sensor,reverse sensor,parking assist sensor",
    "category": "ELECTRICAL",
    "subcategory": "Parking Sensors",
    "part": "Parking Sensor"
  },
  {
    "keywords": "rain sensor,rain light sensor",
    "category": "ELECTRICAL",
    "subcategory": "Rain Sensors",
    "part": "Rain Sensor"
  },
  {
    "keywords": "ecu,ecm,pcm,engine control unit,engine control module,computer,engine computer",
    "category": "ELECTRICAL",
    "subcategory": "ECUs",
    "part": "ECU"
  },
  {
    "keywords": "bcm,body control module,body computer",
    "category": "ELECTRICAL",
    "subcategory": "BCMs",
    "part": "BCM"
  },
  {
    "keywords": "tcm,transmission control module,transmission computer,gearbox control module",
    "category": "ELECTRICAL",
    "subcategory": "TCMs",
    "part": "TCM"
  },
  {
    "keywords": "airbag control module,airbag ecu,srs module",
    "category": "ELECTRICAL",
    "subcategory": "Airbag Modules",
    "part": "Airbag Control Module"
  },
  {
    "keywords": "power distribution center,pdc,fuse box,power distribution module",
    "category": "ELECTRICAL",
    "subcategory": "Power Distribution",
    "part": "Power Distribution Center"
  },
  {
    "keywords": "fuse,fuses,fuse box,fuse block,fuse holder,fuse panel",
    "category": "ELECTRICAL",
    "subcategory": "Fuses",
    "part": "Fuse"
  },
  {
    "keywords": "relay,relays,relay box,automotive relay",
    "category": "ELECTRICAL",
    "subcategory": "Relays",
    "part": "Relay"
  },
  {
    "keywords": "wiring harness,wire harness,loom,harness,electrical harness",
    "category": "ELECTRICAL",
    "subcategory": "Wiring Harnesses",
    "part": "Wiring Harness"
  },
  {
    "keywords": "connector,plug,socket,electrical connector,harness connector,disconnector",
    "category": "ELECTRICAL",
    "subcategory": "Connectors",
    "part": "Connector"
  },
  {
    "keywords": "solenoid,solenoids,solenoid valve,shift solenoid,vvt solenoid",
    "category": "ELECTRICAL",
    "subcategory": "Solenoids",
    "part": "Solenoid"
  },
  {
    "keywords": "window motor,power window motor,window regulator motor,window lift motor",
    "category": "ELECTRICAL",
    "subcategory": "Window Motors",
    "part": "Window Motor"
  },
  {
    "keywords": "wiper motor,windshield wiper motor,wiper arm",
    "category": "ELECTRICAL",
    "subcategory": "Wiper Motors",
    "part": "Wiper Motor"
  },
  {
    "keywords": "radio,stereo,car radio,head unit,infotainment,amplifier,speaker,gps navigation unit,bluetooth module,usb port,12v power outlet",
    "category": "ELECTRICAL",
    "subcategory": "Infotainment",
    "part": "Infotainment Unit"
  },
  {
    "keywords": "keyless entry remote,immobilizer system,alarm system,key fob,remote key",
    "category": "ELECTRICAL",
    "subcategory": "Security Systems",
    "part": "Keyless Entry Remote"
  },
  {
    "keywords": "cruise control module,cruise control ecu,cruise control",
    "category": "ELECTRICAL",
    "subcategory": "Cruise Control",
    "part": "Cruise Control Module"
  },
  {
    "keywords": "door control module,door ecu,glass lift switch,temperature control switch,actuator",
    "category": "ELECTRICAL",
    "subcategory": "Control Modules",
    "part": "Control Module"
  },
  {
    "keywords": "radiator,engine radiator,coolant radiator,radiator assembly,aluminum radiator",
    "category": "COOLING",
    "subcategory": "Radiators",
    "part": "Radiator"
  },
  {
    "keywords": "radiator fan,fan motor,cooling fan,electric fan,fan assembly,radiator cooling fan,fan clutch,fan blade",
    "category": "COOLING",
    "subcategory": "Radiator Fans",
    "part": "Radiator Fan"
  },
  {
    "keywords": "expansion tank,coolant tank,water tank,coolant reservoir,overflow tank,coolant expansion tank",
    "category": "COOLING",
    "subcategory": "Expansion Tanks",
    "part": "Expansion Tank"
  },
  {
    "keywords": "radiator cap,coolant cap,pressure cap,radiator pressure cap",
    "category": "COOLING",
    "subcategory": "Radiator Caps",
    "part": "Radiator Cap"
  },
  {
    "keywords": "radiator hose,coolant hose,upper hose,lower hose,heater hose,radiator hoses,water pipe",
    "category": "COOLING",
    "subcategory": "Radiator Hoses",
    "part": "Radiator Hose"
  },
  {
    "keywords": "intercooler,charge air cooler,intercooler assembly,air to air intercooler,intercooler pipe",
    "category": "COOLING",
    "subcategory": "Intercoolers",
    "part": "Intercooler"
  },
  {
    "keywords": "oil cooler,engine oil cooler,transmission cooler,power steering cooler,oil cooler line",
    "category": "COOLING",
    "subcategory": "Oil Coolers",
    "part": "Oil Cooler"
  },
  {
    "keywords": "condenser,ac condenser,a/c condenser,condensor,air conditioning condenser",
    "category": "COOLING",
    "subcategory": "Condensers",
    "part": "A/C Condenser"
  },
  {
    "keywords": "ac compressor,air compressor,ac compressor assembly,a/c compressor,ac compressor clutch",
    "category": "HVAC",
    "subcategory": "AC Compressors",
    "part": "AC Compressor"
  },
  {
    "keywords": "ac evaporator,evaporator core,evaporator,a/c evaporator,evaporation box",
    "category": "HVAC",
    "subcategory": "AC Evaporators",
    "part": "AC Evaporator"
  },
  {
    "keywords": "ac expansion valve,expansion valve,a/c expansion valve",
    "category": "HVAC",
    "subcategory": "AC Expansion Valves",
    "part": "AC Expansion Valve"
  },
  {
    "keywords": "ac receiver drier,receiver drier,receiver dryer,ac drier,drying bottle",
    "category": "HVAC",
    "subcategory": "AC Receiver Driers",
    "part": "AC Receiver Drier"
  },
  {
    "keywords": "ac accumulator,accumulator,a/c accumulator",
    "category": "HVAC",
    "subcategory": "AC Accumulators",
    "part": "AC Accumulator"
  },
  {
    "keywords": "blower motor,blower fan,hvac blower,heater blower motor,ac fan",
    "category": "HVAC",
    "subcategory": "Blower Motors",
    "part": "Blower Motor"
  },
  {
    "keywords": "blower motor resistor,blower resistor,heater resistor,blower control module",
    "category": "HVAC",
    "subcategory": "Blower Motor Resistors",
    "part": "Blower Motor Resistor"
  },
  {
    "keywords": "heater core,heater matrix,heater radiator,hvac heater core",
    "category": "HVAC",
    "subcategory": "Heater Cores",
    "part": "Heater Core"
  },
  {
    "keywords": "heater control valve,heater valve,heater water valve,water valve",
    "category": "HVAC",
    "subcategory": "Heater Control Valves",
    "part": "Heater Control Valve"
  },
  {
    "keywords": "ac hose,ac line,a/c hose,a/c line,hvac hose,a/c pipe",
    "category": "HVAC",
    "subcategory": "AC Hoses",
    "part": "AC Hose"
  },
  {
    "keywords": "ac pressure switch,ac pressure sensor,a/c pressure sensor,trinary switch",
    "category": "HVAC",
    "subcategory": "AC Pressure Switches",
    "part": "AC Pressure Switch"
  },
  {
    "keywords": "blend door actuator,blend door motor,air door actuator",
    "category": "HVAC",
    "subcategory": "Blend Door Actuators",
    "part": "Blend Door Actuator"
  },
  {
    "keywords": "orifice tube,orifice,ac orifice tube",
    "category": "HVAC",
    "subcategory": "Orifice Tubes",
    "part": "Orifice Tube"
  },
  {
    "keywords": "clutch kit,clutch set,clutch plate,clutch disc,clutch disk,clutch,clutch cover,pressure plate",
    "category": "TRANSMISSION",
    "subcategory": "Clutch Kits",
    "part": "Clutch Kit"
  },
  {
    "keywords": "clutch master cylinder,clutch master,clutch cylinder",
    "category": "TRANSMISSION",
    "subcategory": "Clutch Master Cylinders",
    "part": "Clutch Master Cylinder"
  },
  {
    "keywords": "clutch slave cylinder,clutch slave,slave cylinder,clutch release cylinder",
    "category": "TRANSMISSION",
    "subcategory": "Clutch Slave Cylinders",
    "part": "Clutch Slave Cylinder"
  },
  {
    "keywords": "clutch fork,release fork,clutch release fork",
    "category": "TRANSMISSION",
    "subcategory": "Clutch Forks",
    "part": "Clutch Fork"
  },
  {
    "keywords": "release bearing,throw-out bearing,throw out bearing,clutch bearing,clutch release bearing",
    "category": "TRANSMISSION",
    "subcategory": "Clutch Bearings",
    "part": "Clutch Release Bearing"
  },
  {
    "keywords": "torque converter,torque convertor,torque converter assembly,lockup clutch",
    "category": "TRANSMISSION",
    "subcategory": "Torque Converters",
    "part": "Torque Converter"
  },
  {
    "keywords": "cv axle,axle shaft,drive shaft,driveshaft,cv joint,half shaft,cv axles,driveshaft assembly,cv axle shaft",
    "category": "TRANSMISSION",
    "subcategory": "CV Axles",
    "part": "CV Axle"
  },
  {
    "keywords": "cv boot,cv boot kit,cv joint boot,driveshaft boot",
    "category": "TRANSMISSION",
    "subcategory": "CV Boots",
    "part": "CV Boot"
  },
  {
    "keywords": "propeller shaft,propshaft,drive shaft assembly,rear drive shaft",
    "category": "TRANSMISSION",
    "subcategory": "Drive Shafts",
    "part": "Drive Shaft"
  },
  {
    "keywords": "u-joint,universal joint,u joints,ujoint",
    "category": "TRANSMISSION",
    "subcategory": "U-Joints",
    "part": "U-Joint"
  },
  {
    "keywords": "center bearing,carrier bearing,driveshaft bearing",
    "category": "TRANSMISSION",
    "subcategory": "Center Bearings",
    "part": "Center Bearing"
  },
  {
    "keywords": "differential,diff,rear differential,front differential,limited slip differential,lsd,differential assembly,differential cover,differential bearing kit,ring and pinion gear set,limited slip clutch pack,differential fluid",
    "category": "TRANSMISSION",
    "subcategory": "Differentials",
    "part": "Differential"
  },
  {
    "keywords": "differential seal,pinion seal,axle seal,output shaft seal",
    "category": "TRANSMISSION",
    "subcategory": "Differential Seals",
    "part": "Differential Seal"
  },
  {
    "keywords": "axle shaft,axle,rear axle,front axle,cv axle shaft,axle bearing,axle seal",
    "category": "TRANSMISSION",
    "subcategory": "Axle Shafts",
    "part": "Axle Shaft"
  },
  {
    "keywords": "gearbox,gear box,transmission,manual gearbox,automatic gearbox,auto gearbox,transmission assembly",
    "category": "TRANSMISSION",
    "subcategory": "Gearboxes",
    "part": "Gearbox"
  },
  {
    "keywords": "transmission mount,gearbox mount,transmission mounting",
    "category": "TRANSMISSION",
    "subcategory": "Transmission Mounts",
    "part": "Transmission Mount"
  },
  {
    "keywords": "transmission pan,gearbox pan,transmission pan gasket,atf pan,transmission oil pan",
    "category": "TRANSMISSION",
    "subcategory": "Transmission Pans",
    "part": "Transmission Pan"
  },
  {
    "keywords": "transmission solenoid,shift solenoid,shift solenoid valve,transmission control solenoid,shift cable",
    "category": "TRANSMISSION",
    "subcategory": "Transmission Solenoids",
    "part": "Transmission Solenoid"
  },
  {
    "keywords": "valve body,valvebody,transmission valve body,gearbox valve body,valve body spacer plate,accumulator piston",
    "category": "TRANSMISSION",
    "subcategory": "Valve Bodies",
    "part": "Valve Body"
  },
  {
    "keywords": "transfer case,transfer box,4wd transfer case,transfer case motor,power transfer unit",
    "category": "TRANSMISSION",
    "subcategory": "Transfer Cases",
    "part": "Transfer Case"
  },
  {
    "keywords": "locking hub,4wd actuator,4x4 actuator,4wd switch,four-wheel drive actuator,hub locking mechanism",
    "category": "TRANSMISSION",
    "subcategory": "4WD Actuators",
    "part": "4WD Actuator"
  },
  {
    "keywords": "transmission control mechanism,shift control lever assembly,gear shift knob",
    "category": "TRANSMISSION",
    "subcategory": "Shift Controls",
    "part": "Shift Control Lever Assembly"
  },
  {
    "keywords": "bumper,front bumper,rear bumper,bumper cover,bumper bar,bumper reinforcement",
    "category": "BODY",
    "subcategory": "Bumpers",
    "part": "Bumper"
  },
  {
    "keywords": "fender,wing,mudguard,fender panel,quarter panel,front fender,rear fender",
    "category": "BODY",
    "subcategory": "Fenders",
    "part": "Fender"
  },
  {
    "keywords": "mirror,door mirror,side mirror,wing mirror,rear view mirror,mirror assembly,mirror glass,mirror motor,side mirror cover",
    "category": "BODY",
    "subcategory": "Mirrors",
    "part": "Door Mirror"
  },
  {
    "keywords": "windshield,wind screen,windscreen,front glass,windshield glass,front windscreen",
    "category": "BODY",
    "subcategory": "Windshields",
    "part": "Windshield"
  },
  {
    "keywords": "rear window,rear glass,back glass,rear windscreen",
    "category": "BODY",
    "subcategory": "Rear Windows",
    "part": "Rear Window"
  },
  {
    "keywords": "quarter glass,quarter window,side glass,side window",
    "category": "BODY",
    "subcategory": "Quarter Glass",
    "part": "Quarter Glass"
  },
  {
    "keywords": "grille,grill,front grille,kidney grille,radiator grille,front grill",
    "category": "BODY",
    "subcategory": "Grilles",
    "part": "Grille"
  },
  {
    "keywords": "hood,bonnet,engine hood,engine cover,hood assembly,hood strut,hood prop rod",
    "category": "BODY",
    "subcategory": "Hoods",
    "part": "Hood"
  },
  {
    "keywords": "car door,door shell,door,door panel,front door,rear door,door assembly,door hinge,door seal,door water shield,anti-intrusion bar",
    "category": "BODY",
    "subcategory": "Doors",
    "part": "Door"
  },
  {
    "keywords": "door handle,exterior door handle,interior door handle,outside door handle,inner door handle,outer door handle",
    "category": "BODY",
    "subcategory": "Door Handles",
    "part": "Door Handle"
  },
  {
    "keywords": "door lock,door latch,door actuator,central locking motor,door lock actuator,power door lock,central locking",
    "category": "BODY",
    "subcategory": "Door Locks",
    "part": "Door Lock"
  },
  {
    "keywords": "window regulator,window lift,power window regulator,window regulator assembly",
    "category": "BODY",
    "subcategory": "Window Regulators",
    "part": "Window Regulator"
  },
  {
    "keywords": "window switch,power window switch,window control switch,master window switch,glass lift switch",
    "category": "BODY",
    "subcategory": "Window Switches",
    "part": "Window Switch"
  },
  {
    "keywords": "trunk lid,boot lid,trunk lid assembly,boot lid assembly",
    "category": "BODY",
    "subcategory": "Trunk Lids",
    "part": "Trunk Lid"
  },
  {
    "keywords": "tailgate,hatch,liftgate,tailgate assembly,boot lid,liftgate strut,tailgate assist",
    "category": "BODY",
    "subcategory": "Tailgates",
    "part": "Tailgate"
  },
  {
    "keywords": "rocker panel,side skirt,rocker panel cover",
    "category": "BODY",
    "subcategory": "Rocker Panels",
    "part": "Rocker Panel"
  },
  {
    "keywords": "spoiler,rear wing,rear spoiler,roof spoiler,front spoiler",
    "category": "BODY",
    "subcategory": "Spoilers",
    "part": "Spoiler"
  },
  {
    "keywords": "roof rack,roof rail,roof rails,roof crossbars,roof box",
    "category": "BODY",
    "subcategory": "Roof Racks",
    "part": "Roof Rack"
  },
  {
    "keywords": "sunroof,moonroof,sunroof glass,sunroof motor,sunroof assembly",
    "category": "BODY",
    "subcategory": "Sunroofs",
    "part": "Sunroof"
  },
  {
    "keywords": "fuel door,fuel filler door,gas door,petrol door",
    "category": "BODY",
    "subcategory": "Fuel Doors",
    "part": "Fuel Door"
  },
  {
    "keywords": "emblem,badge,car emblem,logo,marque,nameplate,decal,stripe",
    "category": "BODY",
    "subcategory": "Emblems",
    "part": "Emblem"
  },
  {
    "keywords": "wiper,wiper blade,wiper blades,windshield wiper,wiper arm,wiper linkage",
    "category": "BODY",
    "subcategory": "Wipers",
    "part": "Wiper Blade"
  },
  {
    "keywords": "washer pump,washer nozzle,washer reservoir,windshield washer pump",
    "category": "BODY",
    "subcategory": "Washer Pumps",
    "part": "Washer Pump"
  },
  {
    "keywords": "pillar,a pillar,b pillar,c pillar,pillar trim",
    "category": "BODY",
    "subcategory": "Pillars",
    "part": "Pillar"
  },
  {
    "keywords": "frame rail,crossmember,body mount,body mount bushing,frame,chassis",
    "category": "BODY",
    "subcategory": "Frame & Structure",
    "part": "Frame Rail"
  },
  {
    "keywords": "skid plate,tow hook,recovery point,underbody shield",
    "category": "BODY",
    "subcategory": "Underbody",
    "part": "Skid Plate"
  },
  {
    "keywords": "molding,moulding,trim,garnish,body side molding,door molding,fender molding,rocker panel molding,rocker molding,wheel arch molding,wheel arch trim,roof molding,roof moulding,roof trim,beltline molding,bumper molding,bumper trim,window molding,windshield molding,windshield trim,quarter panel molding,quarter molding,hood molding,grille molding,tailgate molding,trunk molding,molding clip,molding retainer,trim panel,interior trim panel,door card,body cladding,door cladding,fender trim,door trim,body trim",
    "category": "BODY",
    "subcategory": "Moldings & Trim",
    "part": "Molding"
  },
  {
    "keywords": "hood deflector,bug shield,window deflector,weather shield",
    "category": "BODY",
    "subcategory": "Deflectors",
    "part": "Hood Deflector"
  },
  {
    "keywords": "mud guard,mud flap,splash guard",
    "category": "BODY",
    "subcategory": "Mud Flaps",
    "part": "Mud Flap"
  },
  {
    "keywords": "running board,side step,tonneau cover,fender flare",
    "category": "BODY",
    "subcategory": "Accessories",
    "part": "Running Board"
  },
  {
    "keywords": "muffler,exhaust muffler,silencer,exhaust silencer,muffler assembly",
    "category": "EXHAUST",
    "subcategory": "Mufflers",
    "part": "Muffler"
  },
  {
    "keywords": "resonator,exhaust resonator,resonator assembly",
    "category": "EXHAUST",
    "subcategory": "Resonators",
    "part": "Resonator"
  },
  {
    "keywords": "catalytic converter,cat converter,catalytic,cat,catalytic cat,cat converter assembly",
    "category": "EXHAUST",
    "subcategory": "Catalytic Converters",
    "part": "Catalytic Converter"
  },
  {
    "keywords": "exhaust pipe,exhaust pipes,exhaust pipe assembly,exhaust tubing,tailpipe,exhaust tip",
    "category": "EXHAUST",
    "subcategory": "Exhaust Pipes",
    "part": "Exhaust Pipe"
  },
  {
    "keywords": "downpipe,downpipes,exhaust downpipe,turbo downpipe",
    "category": "EXHAUST",
    "subcategory": "Downpipes",
    "part": "Downpipe"
  },
  {
    "keywords": "dpf,dpf filter,diesel particulate filter,particulate filter",
    "category": "EXHAUST",
    "subcategory": "DPF Filters",
    "part": "DPF Filter"
  },
  {
    "keywords": "exhaust gasket,exhaust flange gasket,flange gasket",
    "category": "EXHAUST",
    "subcategory": "Exhaust Gaskets",
    "part": "Exhaust Gasket"
  },
  {
    "keywords": "exhaust hanger,exhaust mount,exhaust bracket,rubber hanger",
    "category": "EXHAUST",
    "subcategory": "Exhaust Hangers",
    "part": "Exhaust Hanger"
  },
  {
    "keywords": "flex pipe,flex joint,flexible pipe,exhaust flex pipe",
    "category": "EXHAUST",
    "subcategory": "Flex Pipes",
    "part": "Flex Pipe"
  },
  {
    "keywords": "egr pipe,egr tube,egr line,exhaust gas recirculation pipe",
    "category": "EXHAUST",
    "subcategory": "EGR Pipes",
    "part": "EGR Pipe"
  },
  {
    "keywords": "evaporative emission canister,purge valve,evap canister,charcoal canister",
    "category": "EXHAUST",
    "subcategory": "EVAP Systems",
    "part": "Evaporative Emission Canister"
  },
  {
    "keywords": "exhaust tip,tailpipe tip,chrome tip",
    "category": "EXHAUST",
    "subcategory": "Exhaust Tips",
    "part": "Exhaust Tip"
  },
  {
    "keywords": "fuel pump,fuel pump module,petrol pump,in-tank fuel pump,fuel pump assembly",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Pumps",
    "part": "Fuel Pump"
  },
  {
    "keywords": "fuel injector,injector,injectors,fuel injectors,petrol injector,fuel nozzle,injector set",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Injectors",
    "part": "Fuel Injector"
  },
  {
    "keywords": "throttle body,throttle valve,throttle assembly,electronic throttle body,throttle body assembly",
    "category": "FUEL SYSTEM",
    "subcategory": "Throttle Bodies",
    "part": "Throttle Body"
  },
  {
    "keywords": "fuel rail,fuel rails,fuel rail assembly,injector rail",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Rails",
    "part": "Fuel Rail"
  },
  {
    "keywords": "fuel line,fuel lines,fuel hose,fuel pipe",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Lines",
    "part": "Fuel Line"
  },
  {
    "keywords": "fuel pressure regulator,fuel regulator,pressure regulator,fuel pressure sensor",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Pressure Regulators",
    "part": "Fuel Pressure Regulator"
  },
  {
    "keywords": "fuel tank,fuel tanks,petrol tank,gas tank,fuel tank assembly,fuel filler neck",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Tanks",
    "part": "Fuel Tank"
  },
  {
    "keywords": "fuel cap,gas cap,petrol cap,fuel filler cap",
    "category": "FUEL SYSTEM",
    "subcategory": "Fuel Caps",
    "part": "Fuel Cap"
  },
  {
    "keywords": "carburetor,carb,carburetors,carburettor,weber carb",
    "category": "FUEL SYSTEM",
    "subcategory": "Carburetors",
    "part": "Carburetor"
  },
  {
    "keywords": "throttle cable,accelerator cable,gas pedal cable",
    "category": "FUEL SYSTEM",
    "subcategory": "Throttle Cables",
    "part": "Throttle Cable"
  },
  {
    "keywords": "seat,seats,car seat,seat frame,seat cover,seat assembly,seat back frame,seat cushion,headrest,headrestraint,third row seat,seat fold actuator,seat under tray,reclining cover",
    "category": "INTERIOR",
    "subcategory": "Seats",
    "part": "Seat"
  },
  {
    "keywords": "seat belt,seatbelt,safety belt,seat belts,seat belt assembly,seat belt pretensioner",
    "category": "INTERIOR",
    "subcategory": "Seat Belts",
    "part": "Seat Belt"
  },
  {
    "keywords": "dashboard,dash,instrument panel,dashboard assembly,dash panel,dashboard fascia",
    "category": "INTERIOR",
    "subcategory": "Dashboards",
    "part": "Dashboard"
  },
  {
    "keywords": "instrument cluster,gauge cluster,instrument panel cluster,speedometer cluster,speedometer,tachometer,fuel gauge,temperature gauge",
    "category": "INTERIOR",
    "subcategory": "Instrument Clusters",
    "part": "Instrument Cluster"
  },
  {
    "keywords": "steering wheel,steering wheel assembly,leather steering wheel,steering wheel cover",
    "category": "INTERIOR",
    "subcategory": "Steering Wheels",
    "part": "Steering Wheel"
  },
  {
    "keywords": "airbag,air bag,airbags,airbag module,srs airbag,side airbag,fastener for side airbag",
    "category": "INTERIOR",
    "subcategory": "Airbags",
    "part": "Airbag"
  },
  {
    "keywords": "clock spring,spiral cable,clockspring,airbag clock spring",
    "category": "INTERIOR",
    "subcategory": "Clock Springs",
    "part": "Clock Spring"
  },
  {
    "keywords": "center console,console,center console assembly,armrest console,console lid,center console lid",
    "category": "INTERIOR",
    "subcategory": "Center Consoles",
    "part": "Center Console"
  },
  {
    "keywords": "shifter,gear shifter,shift knob,gear lever,gear selector,gear shift knob,manual shift knob,automatic shift knob,transmission shifter,shift boot,gear shift boot,shifter assembly,transfer case shifter,parking brake handle,e-brake handle,handbrake handle",
    "category": "INTERIOR",
    "subcategory": "Shifters",
    "part": "Gear Shifter"
  },
  {
    "keywords": "carpet,floor carpet,cabin carpet,floor covering",
    "category": "INTERIOR",
    "subcategory": "Carpets",
    "part": "Carpet"
  },
  {
    "keywords": "floor mat,floor mats,car mat,carpet mat,rubber mat",
    "category": "INTERIOR",
    "subcategory": "Floor Mats",
    "part": "Floor Mat"
  },
  {
    "keywords": "headliner,roof liner,headlining,roof lining,headlining panel",
    "category": "INTERIOR",
    "subcategory": "Headliners",
    "part": "Headliner"
  },
  {
    "keywords": "rearview mirror,rear view mirror,interior mirror,auto dimming mirror",
    "category": "INTERIOR",
    "subcategory": "Rearview Mirrors",
    "part": "Rearview Mirror"
  },
  {
    "keywords": "sun visor,sunvisor,sun visors,vanity mirror,sun visor clip",
    "category": "INTERIOR",
    "subcategory": "Sun Visors",
    "part": "Sun Visor"
  },
  {
    "keywords": "glove box,glovebox,glove compartment",
    "category": "INTERIOR",
    "subcategory": "Glove Boxes",
    "part": "Glove Box"
  },
  {
    "keywords": "cup holder,cupholder,drink holder",
    "category": "INTERIOR",
    "subcategory": "Cup Holders",
    "part": "Cup Holder"
  },
  {
    "keywords": "armrest,arm rest,center armrest",
    "category": "INTERIOR",
    "subcategory": "Armrests",
    "part": "Armrest"
  },
  {
    "keywords": "door sill,sill scuff plate,scuff plate",
    "category": "INTERIOR",
    "subcategory": "Door Sills",
    "part": "Door Sill"
  },
  {
    "keywords": "cargo cover,cargo net,parcel shelf,boot liner",
    "category": "INTERIOR",
    "subcategory": "Cargo Accessories",
    "part": "Cargo Cover"
  },
  {
    "keywords": "seat heater,seat heater element,heated seat",
    "category": "INTERIOR",
    "subcategory": "Seat Heaters",
    "part": "Seat Heater"
  },
  {
    "keywords": "wheel,wheels,rim,rims,alloy wheel,steel wheel,wheel rim",
    "category": "WHEELS",
    "subcategory": "Wheels",
    "part": "Wheel"
  },
  {
    "keywords": "tire,tires,tyre,tyres,car tire,tubeless tire,radial tire",
    "category": "WHEELS",
    "subcategory": "Tires",
    "part": "Tire"
  },
  {
    "keywords": "hubcap,hubcaps,wheel cover,wheel covers,rim cover",
    "category": "WHEELS",
    "subcategory": "Hubcaps",
    "part": "Hubcap"
  },
  {
    "keywords": "wheel spacer,wheel spacers,spacer,wheel adapter",
    "category": "WHEELS",
    "subcategory": "Wheel Spacers",
    "part": "Wheel Spacer"
  },
  {
    "keywords": "valve stem,valve stems,tire valve stem,tpms valve stem",
    "category": "WHEELS",
    "subcategory": "Valve Stems",
    "part": "Valve Stem"
  },
  {
    "keywords": "bolt,bolts,hex bolt,head bolt,head bolts,cylinder head bolt",
    "category": "HARDWARE",
    "subcategory": "Bolts",
    "part": "Bolt"
  },
  {
    "keywords": "nut,nuts,hex nut,lock nut,flange nut",
    "category": "HARDWARE",
    "subcategory": "Nuts",
    "part": "Nut"
  },
  {
    "keywords": "lug nut,lug nuts,wheel nut,wheel nuts,acorn nut",
    "category": "HARDWARE",
    "subcategory": "Lug Nuts",
    "part": "Lug Nut"
  },
  {
    "keywords": "lug bolt,lug bolts,wheel bolt,wheel bolts",
    "category": "HARDWARE",
    "subcategory": "Lug Bolts",
    "part": "Lug Bolt"
  },
  {
    "keywords": "wheel stud,wheel studs,stud,studs,axle stud",
    "category": "HARDWARE",
    "subcategory": "Wheel Studs",
    "part": "Wheel Stud"
  },
  {
    "keywords": "screw,screws,washer,washers,clip,clips,retainer,retainers,bracket,brackets,clamp,clamps,grommet,grommets,hose clamp,cable tie,rivet,rivets,snap ring,circlip,spacer,spacers,fastener,fasteners,dowel pin,cotter pin",
    "category": "HARDWARE",
    "subcategory": "Universal Hardware",
    "part": "Hardware"
  },
  {
    "keywords": "traction battery,high voltage battery,hv battery,traction battery pack,ev battery",
    "category": "EV",
    "subcategory": "Traction Batteries",
    "part": "Traction Battery Pack"
  },
  {
    "keywords": "battery management system,bms,battery management",
    "category": "EV",
    "subcategory": "Battery Management Systems",
    "part": "Battery Management System"
  },
  {
    "keywords": "battery module,ev battery module,battery modules",
    "category": "EV",
    "subcategory": "Battery Modules",
    "part": "Battery Module"
  },
  {
    "keywords": "battery cell,ev battery cell,battery cells",
    "category": "EV",
    "subcategory": "Battery Cells",
    "part": "Battery Cell"
  },
  {
    "keywords": "high voltage harness,hv wiring harness,high voltage wiring harness,ev harness",
    "category": "EV",
    "subcategory": "HV Wiring Harnesses",
    "part": "High-Voltage Wiring Harness"
  },
  {
    "keywords": "manual power disconnect,service disconnect,power disconnect unit,msd",
    "category": "EV",
    "subcategory": "Power Disconnects",
    "part": "Manual Power Disconnect Unit"
  },
  {
    "keywords": "traction motor,electric motor,drive motor,ev motor",
    "category": "EV",
    "subcategory": "Traction Motors",
    "part": "Traction Motor"
  },
  {
    "keywords": "motor control unit,mcu,motor controller,inverter controller",
    "category": "EV",
    "subcategory": "Motor Control Units",
    "part": "Motor Control Unit"
  },
  {
    "keywords": "inverter,dc ac inverter,power inverter,ev inverter",
    "category": "EV",
    "subcategory": "Inverters",
    "part": "Inverter"
  },
  {
    "keywords": "dc-dc converter,dc to dc converter,dcdc converter,converter",
    "category": "EV",
    "subcategory": "DC-DC Converters",
    "part": "DC-DC Converter"
  },
  {
    "keywords": "on-board charger,onboard charger,obc,on board charger",
    "category": "EV",
    "subcategory": "On-Board Chargers",
    "part": "On-Board Charger"
  },
  {
    "keywords": "charge port,charging port,charge inlet,charging socket",
    "category": "EV",
    "subcategory": "Charge Ports",
    "part": "Charge Port"
  },
  {
    "keywords": "ptc heater,ev heater,cabin heater,high voltage heater",
    "category": "EV",
    "subcategory": "PTC Heaters",
    "part": "PTC Heater"
  },
  {
    "keywords": "electric ac compressor,electric a/c compressor,ev ac compressor,high voltage ac compressor",
    "category": "EV",
    "subcategory": "Electric A/C Compressors",
    "part": "Electric A/C Compressor"
  },
  {
    "keywords": "power distribution unit,pdu,power distribution module",
    "category": "EV",
    "subcategory": "Power Distribution Units",
    "part": "Power Distribution Unit"
  },
  {
    "keywords": "48v brm,boost recuperation machine,brm,48v starter generator",
    "category": "EV",
    "subcategory": "48V BRM",
    "part": "48V Boost Recuperation Machine"
  },
  {
    "keywords": "starter generator,starter-generator,integrated starter generator,isg",
    "category": "EV",
    "subcategory": "Starter-Generators",
    "part": "Starter-Generator"
  },
  {
    "keywords": "electric axle drive,e-drive,edrive,e axle",
    "category": "EV",
    "subcategory": "E-Drive Axles",
    "part": "Electric Axle Drive"
  },
  {
    "keywords": "reduction gearbox,reduction gear,ev gearbox,single speed gearbox",
    "category": "EV",
    "subcategory": "Reduction Gearboxes",
    "part": "Reduction Gearbox"
  },
  {
    "keywords": "regenerative braking,regen braking,regen system",
    "category": "EV",
    "subcategory": "Regenerative Braking",
    "part": "Regenerative Braking System"
  },
  {
    "keywords": "battery cooling,battery thermal management,ev cooling",
    "category": "EV",
    "subcategory": "Battery Cooling",
    "part": "Battery Cooling System"
  },
  {
    "keywords": "thermal management system,thermal management,ev thermal",
    "category": "EV",
    "subcategory": "Thermal Management",
    "part": "Thermal Management System"
  },
  {
    "keywords": "front camera,rear camera,side camera,backup camera,camera module,adas camera",
    "category": "ADAS",
    "subcategory": "Cameras",
    "part": "Camera"
  },
  {
    "keywords": "radar sensor,radar,long range radar,short range radar,mmwave radar",
    "category": "ADAS",
    "subcategory": "Radar Sensors",
    "part": "Radar Sensor"
  },
  {
    "keywords": "lidar,lidar sensor,lidar module,laser scanner",
    "category": "ADAS",
    "subcategory": "LiDAR Sensors",
    "part": "LiDAR Sensor"
  },
  {
    "keywords": "ultrasonic sensor,uss sensor,park sensor,ultrasonic",
    "category": "ADAS",
    "subcategory": "Ultrasonic Sensors",
    "part": "Ultrasonic Sensor"
  },
  {
    "keywords": "infrared sensor,ir sensor,infrared camera",
    "category": "ADAS",
    "subcategory": "Infrared Sensors",
    "part": "Infrared Sensor"
  },
  {
    "keywords": "gps antenna,navigation antenna,gnss antenna,gps module",
    "category": "ADAS",
    "subcategory": "GPS Antennas",
    "part": "GPS Antenna"
  },
  {
    "keywords": "v2x module,v2x,vehicle to everything,vehicle-to-everything",
    "category": "ADAS",
    "subcategory": "V2X Modules",
    "part": "V2X Module"
  },
  {
    "keywords": "adas ecu,adas control unit,adas module,adas computer",
    "category": "ADAS",
    "subcategory": "ADAS ECUs",
    "part": "ADAS ECU"
  },
  {
    "keywords": "domain controller,domain ecu,zonal controller",
    "category": "ADAS",
    "subcategory": "Domain Controllers",
    "part": "Domain Controller"
  },
  {
    "keywords": "sensor fusion,sensor fusion module,fusion module",
    "category": "ADAS",
    "subcategory": "Sensor Fusion",
    "part": "Sensor Fusion Module"
  },
  {
    "keywords": "lane departure warning,ldw module,lane keep assist,lka",
    "category": "ADAS",
    "subcategory": "Lane Departure Modules",
    "part": "Lane Departure Warning Module"
  },
  {
    "keywords": "adaptive cruise control,acc module,cruise control module",
    "category": "ADAS",
    "subcategory": "Adaptive Cruise Control",
    "part": "Adaptive Cruise Control Module"
  },
  {
    "keywords": "automatic emergency braking,aeb module,emergency braking",
    "category": "ADAS",
    "subcategory": "AEB Modules",
    "part": "Automatic Emergency Braking Module"
  },
  {
    "keywords": "blind spot monitoring,bsm module,blind spot detection",
    "category": "ADAS",
    "subcategory": "Blind Spot Modules",
    "part": "Blind Spot Monitoring Module"
  },
  {
    "keywords": "park assist,park assist module,self parking,automatic parking",
    "category": "ADAS",
    "subcategory": "Park Assist",
    "part": "Park Assist Module"
  },
  {
    "keywords": "hd mapping,hd map,high definition mapping",
    "category": "ADAS",
    "subcategory": "HD Mapping",
    "part": "HD Mapping Module"
  },
  {
    "keywords": "hill descent control,hdc module,hill descent",
    "category": "ADAS",
    "subcategory": "Hill Descent Control",
    "part": "Hill Descent Control Module"
  },
  {
    "keywords": "terrain response,terrain management,drive mode controller",
    "category": "ADAS",
    "subcategory": "Terrain Response",
    "part": "Terrain Response Module"
  },
  {
    "keywords": "engine oil,motor oil,transmission fluid,brake fluid,coolant,antifreeze,power steering fluid,differential fluid,ac refrigerant,windshield washer fluid,grease,adhesive,sealant,lubricant,sulphuric acid,distilled water",
    "category": "GENERAL",
    "subcategory": "Fluids & Chemicals",
    "part": "Fluid"
  },
  {
    "keywords": "jack,lug wrench,tire iron,spare tire,tire repair kit,jumper cables,fire extinguisher,warning triangle,first aid kit,electric winch,tire air pump,license plate frame,weather shield",
    "category": "GENERAL",
    "subcategory": "Tools & Equipment",
    "part": "Tool"
  }
]

// Standalone subcategories map derived directly from canonical categories and keyword taxonomy
export const SUBCATEGORIES: Record<string, string[]> = Object.freeze((() => {
  const map: Record<string, string[]> = {};
  for (const cat of CANONICAL_CATEGORIES) {
    map[cat] = [];
  }
  for (const entry of PART_KEYWORDS) {
    if (entry.category && entry.subcategory) {
      if (!map[entry.category]) map[entry.category] = [];
      if (!map[entry.category].includes(entry.subcategory)) {
        map[entry.category].push(entry.subcategory);
      }
    }
  }
  return map;
})());

// ============================================================================
// Parts4Drive Catalog Management Core Engine
// Handles Category Mapping, Normalized Suffix Cleanups, and MMYTE Validation Matrix
// ============================================================================

export const CATALOG_TAXONOMY = {
  DRV: {
    code: "DRV",
    name: "Drivetrain & Transmission",
    subcategories: {
      "cv joint": "CVJ",
      "axle shaft": "AXL",
      "clutch kit": "CLU",
      "gearbox": "GRB",
      "torque converter": "TRQ",
      "driveshaft": "DRS"
    }
  },
  LGT: {
    code: "LGT",
    name: "Lighting & Electrical",
    subcategories: {
      "headlight assembly": "HDL",
      "tail light assembly": "TLG",
      "fog light": "FGL",
      "alternator": "ALT",
      "starter motor": "STR",
      "wiring harness": "WIR"
    }
  },
  BDY: {
    code: "BDY",
    name: "Body & Structure",
    subcategories: {
      "front grille": "GRL",
      "front bumper": "FBP",
      "rear bumper": "RBP",
      "fender": "FND",
      "hood bonnet": "HDD",
      "door shell": "DOR",
      "cowl panel": "CWL"
    }
  },
  ENG: {
    code: "ENG",
    name: "Engine Components",
    subcategories: {
      "piston ring": "PST",
      "cylinder head": "HDG",
      "timing belt": "TMB",
      "spark plug": "SPK",
      "oil pump": "PMP",
      "gasket set": "GSK"
    }
  },
  BRK: {
    code: "BRK",
    name: "Brake System",
    subcategories: {
      "brake pad": "PAD",
      "brake rotor": "RTR",
      "caliper": "CLP",
      "brake master cylinder": "BMC"
    }
  },
  SUS: {
    code: "SUS",
    name: "Suspension & Steering",
    subcategories: {
      "shock absorber": "SHK",
      "control arm": "ARM",
      "ball joint": "BLJ",
      "tie rod end": "TRE"
    }
  }
};

export function resolveCategoryFromTitle(productTitle: string): { category: string; subcategory: string } {
  if (!productTitle) {
    return { category: "GEN", subcategory: "GEN" };
  }

  const titleLower = productTitle.toLowerCase().trim();

  for (const [, catMeta] of Object.entries(CATALOG_TAXONOMY)) {
    for (const [subName, subCode] of Object.entries(catMeta.subcategories)) {
      if (titleLower.includes(subName)) {
        return {
          category: catMeta.code,
          subcategory: subCode
        };
      }
    }
  }

  if (titleLower.includes("bumper") || titleLower.includes("facia")) {
    return { category: "BDY", subcategory: "FBP" };
  }
  if (titleLower.includes("light") || titleLower.includes("lamp") || titleLower.includes("bulb") || titleLower.includes("headlight")) {
    return { category: "LGT", subcategory: "HDL" };
  }
  if (titleLower.includes("joint") || titleLower.includes("drive") || titleLower.includes("axle")) {
    return { category: "DRV", subcategory: "CVJ" };
  }
  if (titleLower.includes("grill")) {
    return { category: "BDY", subcategory: "GRL" };
  }
  if (titleLower.includes("brake") || titleLower.includes("rotor") || titleLower.includes("pad")) {
    return { category: "BRK", subcategory: "PAD" };
  }
  if (titleLower.includes("shock") || titleLower.includes("strut") || titleLower.includes("suspension") || titleLower.includes("arm")) {
    return { category: "SUS", subcategory: "SHK" };
  }
  if (titleLower.includes("engine") || titleLower.includes("piston") || titleLower.includes("timing")) {
    return { category: "ENG", subcategory: "PST" };
  }

  return { category: "BDY", subcategory: "GEN" };
}

export function slugifyField(value: any): string {
  if (!value) return "GEN";
  return value
    .toString()
    .toUpperCase()
    .trim()
    .replace(/[^A-Z0-9]/g, "")
    .substring(0, 4);
}

const CANONICAL_MAKE_CODES: Record<string, string> = {
  toyota: 'TY',
  lexus: 'LX',
  honda: 'HN',
  acura: 'AC',
  nissan: 'NS',
  infiniti: 'IN',
  mercedes: 'MB',
  'mercedes-benz': 'MB',
  bmw: 'BM',
  audi: 'AU',
  volkswagen: 'VW',
  ford: 'FD',
  hyundai: 'HY',
  kia: 'KA',
  mitsubishi: 'MS',
  peugeot: 'PG',
  landrover: 'LR',
  'land-rover': 'LR',
  mazda: 'MZ',
  suzuki: 'SZ',
  subaru: 'SB',
  chevrolet: 'CH',
  isuzu: 'IS',
  renault: 'RN',
};

const CANONICAL_MODEL_CODES: Record<string, string> = {
  corolla: 'CO',
  camry: 'CA',
  hilux: 'HX',
  'land cruiser': 'LC',
  prado: 'PR',
  highlander: 'HL',
  rav4: 'RA',
  yaris: 'YA',
  avensis: 'AV',
  sienna: 'SI',
  matrix: 'MX',
  tacoma: 'TC',
  tundra: 'TU',
  '4runner': '4R',
  fortuner: 'FT',
  civic: 'CI',
  accord: 'AC',
  'cr-v': 'CR',
  crv: 'CR',
  pilot: 'PI',
  fit: 'FT',
  city: 'CT',
  'hr-v': 'HR',
  hrv: 'HR',
  odyssey: 'OD',
  altima: 'AL',
  sentra: 'SE',
  maxima: 'MA',
  rogue: 'RO',
  murano: 'MU',
  pathfinder: 'PF',
  patrol: 'PT',
  sunny: 'SU',
  versa: 'VE',
  'c-class': 'CC',
  'e-class': 'EC',
  's-class': 'SC',
  'g-class': 'GC',
  gla: 'GA',
  glc: 'GL',
  gle: 'GE',
  gls: 'GS',
  ml: 'ML',
  '3 series': '3S',
  '5 series': '5S',
  '7 series': '7S',
  x3: 'X3',
  x5: 'X5',
  x6: 'X6',
  elantra: 'EL',
  sonata: 'SO',
  accent: 'AT',
  tucson: 'TU',
  'santa fe': 'SF',
  rio: 'RI',
  forte: 'FO',
  optima: 'OP',
  sportage: 'SP',
  sorento: 'SR',
};

export function generateVendorSKU(params: {
  vendorId?: string;
  countryCode?: string;
  regionCode?: string;
  make?: string;
  model?: string;
  year?: string | number;
  productTitle?: string;
} = {}): string {
  const {
    vendorId = "0000",
    countryCode = "GH",
    regionCode = "ACC",
    make = "TY",
    model = "CO",
    year = "00",
    productTitle = ""
  } = params;

  const cleanVendor = slugifyField(vendorId).padEnd(4, "X").substring(0, 4);
  const cleanCountry = slugifyField(countryCode).substring(0, 2);
  const cleanRegion = slugifyField(regionCode).substring(0, 3);
  
  const mLower = String(make || '').trim().toLowerCase();
  const cleanMake = CANONICAL_MAKE_CODES[mLower] || slugifyField(make).substring(0, 2);

  const modLower = String(model || '').trim().toLowerCase();
  const cleanModel = CANONICAL_MODEL_CODES[modLower] || slugifyField(model).substring(0, 2);
  
  let cleanYear = "00";
  if (year) {
    const rawYear = year.toString().replace(/[^0-9]/g, "");
    cleanYear = rawYear.length >= 4 ? rawYear.substring(2, 4) : rawYear.padStart(2, "0");
  }

  const { category, subcategory } = resolveCategoryFromTitle(productTitle);

  return `P4D-${cleanVendor}-${cleanCountry}-${cleanRegion}-${cleanMake}-${cleanModel}-${cleanYear}-${category}-${subcategory}`;
}


